/* Claude 2026-10-09: moved out of snippets/fb-feeding-calc.liquid so the browser caches it and loads it once, even when the calculator renders twice (desktop tab + mobile accordion). The window.fbfcInit guard below keeps it to one run. */
/* Foderbasker foderberegner (fbfc) v2.
   1. Uses the manufacturer's feeding table (custom.feeding_guide) when it fits the animal.
   2. Otherwise estimates from the food's energy (custom.energy, else modified Atwater from
      custom.analytical_constituents) and FEDIAF/NRC energy needs for life stage and activity.
   3. When another food fits better (puppy on adult food, too big for a small-breed food, the maker's
      "switch to X"), shows the server-rendered product cards [data-fbfc-alt] for that situation.
   Bag sizes come from the server-rendered [data-fbfc-size] cards. */
(function () {
  if (window.fbfcInit) return;
  window.fbfcInit = true;

  /* ---------- parsing ---------- */
  function dkNum(s) {
    s = String(s).trim();
    var m = s.match(/^(\d+)\s+(\d+)\/(\d+)$/); // "1 1/2"
    if (m) return +m[1] + m[2] / m[3];
    m = s.match(/^(\d+)\/(\d+)$/); // "3/4"
    if (m) return m[1] / m[2];
    s = s.replace(/(\d)\.(\d{3})(?!\d)/g, '$1$2').replace(',', '.'); // "1.000" -> 1000, "7,5" -> 7.5
    var n = parseFloat(s);
    return isNaN(n) ? null : n;
  }
  // "30-55 g", "85 g", "1 1/2-2 1/4" -> [lo, hi] or null
  function parseRange(s) {
    s = String(s).replace(/\s*(g|kg|gram|stk\.?)\s*$/i, '').trim();
    var parts = s.split(/\s*[-–]\s*/);
    if (parts.length === 2) {
      var a = dkNum(parts[0]), b = dkNum(parts[1]);
      if (a !== null && b !== null) return [a, b];
    }
    var v = dkNum(s);
    return v === null || !/^[\d\s.,/]+$/.test(s) ? null : [v, v];
  }
  // Row label: "1-3 kg", "5 kg", "Op til 5 kg", "Over 30 kg", "2-4 måneder" -> {lo, hi}
  function parseAxis(s) {
    var t = String(s).toLowerCase().replace(/(kg|måneder|mdr\.?|år)/g, '').trim();
    var m = t.match(/^op til\s+(.+)$/);
    if (m) { var u = dkNum(m[1]); return u === null ? null : { lo: u, hi: u }; }
    m = t.match(/^over\s+(.+)$/);
    if (m) { var o = dkNum(m[1]); return o === null ? null : { lo: o, hi: Infinity, over: true }; }
    var r = parseRange(t);
    return r ? { lo: r[0], hi: r[1] } : null;
  }
  // A table cell -> {lo, hi, extra} in grams of THIS product, or {text}
  function parseCell(s, unitGrams) {
    s = String(s).trim();
    var combo = s.match(/^([\d.,]+)\s*g\s*\+\s*([\d.,]+)\s*g$/i); // "35 g + 85 g": dry + this wet food
    if (combo) { var w = dkNum(combo[2]); return { lo: w, hi: w, extra: dkNum(combo[1]) }; }
    var r = parseRange(s);
    if (!r) return { text: s };
    var f = unitGrams || 1;
    return { lo: r[0] * f, hi: r[1] * f };
  }
  // Column header -> chip label {main, sub}
  function modeLabel(c) {
    var t = c.replace(/\(?\s*g(ram)? pr\.? dag\s*\)?/gi, '').replace(/,?\s*gram pr\. dag/gi, '')
      .replace(/[()]/g, '').replace(/\s+/g, ' ').replace(/^[\s,]+|[\s,]+$/g, '');
    if (!t) return null;
    t = t.charAt(0).toUpperCase() + t.slice(1);
    var i = t.indexOf(', ');
    return i > 0 ? { main: t.slice(0, i), sub: t.slice(i + 2) } : { main: t, sub: '' };
  }
  // Energy: "364,4 kcal pr. 100 g (3.644 kcal/kg)", "3.930 kcal/kg (...)" -> kcal per kg
  function parseEnergy(s) {
    s = String(s || '');
    var m = s.match(/([\d.,]+)\s*kcal\s*\/\s*kg/i);
    if (m) return dkNum(m[1]);
    m = s.match(/([\d.,]+)\s*kcal\s*(pr\.?|per|\/)\s*100\s*g/i);
    if (m) return dkNum(m[1]) * 10;
    return null;
  }
  // Modified Atwater (NRC 2006): 3.5 kcal/g protein, 8.5 fat, 3.5 carbohydrate (NFE)
  function atwater(ac, wet) {
    if (!ac || !ac.length) return null;
    var v = {};
    ac.forEach(function (a) {
      var l = String(a.label || '').toLowerCase(), n = dkNum(String(a.value || '').replace('%', ''));
      if (n === null) return;
      if (/protein/.test(l)) v.p = n;
      else if (/fedt|fat/.test(l) && !/syre|omega/.test(l)) v.f = n;
      else if (/træstof|fiber|fibre/.test(l)) v.fi = n;
      else if (/aske/.test(l)) v.a = n;
      else if (/^vand|fugt|moisture/.test(l)) v.w = n;
    });
    if (v.p === undefined || v.f === undefined) return null;
    var w = v.w !== undefined ? v.w : (wet ? 78 : 9);
    var nfe = Math.max(0, 100 - v.p - v.f - (v.fi !== undefined ? v.fi : (wet ? 0.5 : 3)) - (v.a !== undefined ? v.a : (wet ? 2.5 : 7)) - w);
    return (3.5 * v.p + 8.5 * v.f + 3.5 * nfe) * 10;
  }

  /* ---------- interpolation ---------- */
  // rows: [[axisLabel, cell]] -> {min, max, texts, at(x)}
  function curve(rows, unitGrams) {
    var pts = [], texts = [];
    rows.forEach(function (r) {
      var ax = parseAxis(r[0]); if (!ax) return;
      var c = parseCell(r[1], unitGrams);
      if (c.text) { texts.push({ at: ax.lo, text: c.text }); return; }
      if (ax.hi !== ax.lo && isFinite(ax.hi)) {
        if (c.lo !== c.hi) { pts.push({ x: ax.lo, lo: c.lo, hi: c.lo, e: c.extra }); pts.push({ x: ax.hi, lo: c.hi, hi: c.hi, e: c.extra }); }
        else pts.push({ x: (ax.lo + ax.hi) / 2, lo: c.lo, hi: c.hi, e: c.extra, from: ax.lo, to: ax.hi });
      } else pts.push({ x: ax.lo, lo: c.lo, hi: c.hi, e: c.extra });
    });
    pts.sort(function (a, b) { return a.x - b.x; });
    var m = [];
    pts.forEach(function (p) {
      var last = m[m.length - 1];
      if (last && Math.abs(last.x - p.x) < 1e-9) { last.lo = (last.lo + p.lo) / 2; last.hi = (last.hi + p.hi) / 2; }
      else m.push(p);
    });
    var minX = m.length ? (m[0].from !== undefined ? m[0].from : m[0].x) : 0;
    var lastP = m[m.length - 1];
    var maxX = m.length ? (lastP.to !== undefined ? lastP.to : lastP.x) : 0;
    return {
      min: minX, max: maxX, texts: texts,
      at: function (x) {
        if (!m.length) return texts.length ? { text: texts[0].text } : null;
        var t = texts.filter(function (tt) { return x > maxX && tt.at >= maxX - 1e-9; })[0];
        if (t) return { text: t.text };
        if (x < minX - 1e-9) return { below: true, lo: m[0].lo, hi: m[0].hi, e: m[0].e };
        if (x > maxX + 1e-9) return { above: true, lo: lastP.lo, hi: lastP.hi, e: lastP.e };
        if (x <= m[0].x) return { lo: m[0].lo, hi: m[0].hi, e: m[0].e };
        for (var i = 1; i < m.length; i++) {
          if (x <= m[i].x) {
            var a = m[i - 1], b = m[i], k = (x - a.x) / (b.x - a.x);
            return { lo: a.lo + k * (b.lo - a.lo), hi: a.hi + k * (b.hi - a.hi), e: a.e === undefined ? undefined : a.e + k * ((b.e || 0) - a.e) };
          }
        }
        return { lo: lastP.lo, hi: lastP.hi, e: lastP.e };
      }
    };
  }
  function lerp(tbl, x) {
    if (x <= tbl[0][0]) return tbl[0][1];
    for (var i = 1; i < tbl.length; i++) if (x <= tbl[i][0]) { var a = tbl[i - 1], b = tbl[i]; return a[1] + (x - a[0]) / (b[0] - a[0]) * (b[1] - a[1]); }
    return tbl[tbl.length - 1][1];
  }

  /* ---------- energy needs (FEDIAF 2021 / NRC 2006) ---------- */
  // Share of adult weight by age in months, by expected adult size
  var GROW = {
    s: [[1, .15], [2, .3], [3, .45], [4, .6], [5, .72], [6, .82], [8, .93], [10, .98], [12, 1]],
    m: [[1, .1], [2, .2], [3, .3], [4, .42], [5, .54], [6, .65], [8, .8], [10, .9], [12, .97], [15, 1]],
    l: [[1, .08], [2, .15], [3, .24], [4, .34], [5, .44], [6, .53], [8, .68], [10, .8], [12, .88], [15, .95], [18, 1]],
    g: [[1, .06], [2, .12], [3, .19], [4, .27], [5, .36], [6, .45], [8, .6], [10, .72], [12, .82], [15, .92], [18, .97], [24, 1]],
    cat: [[1, .12], [2, .25], [3, .36], [4, .47], [5, .57], [6, .66], [8, .8], [10, .9], [12, .97], [14, 1]]
  };
  function growShare(cat, adult, age) {
    var t = cat ? GROW.cat : adult < 10 ? GROW.s : adult < 25 ? GROW.m : adult < 45 ? GROW.l : GROW.g;
    return lerp(t, age);
  }
  function adultAgeDone(cat, adult) { return cat ? 12 : adult < 10 ? 10 : adult < 25 ? 12 : adult < 45 ? 15 : 20; }
  // Activity: k = kcal per kg^0.75 a day for dogs. FEDIAF 2021 / NRC 2006: 95 for typical pet dogs with low activity,
  // 110 moderate, 125 high-impact, 150-175 working. The makers' own tables in this shop imply about 80-95 for an ordinary
  // adult dog (Platinum ~94, Profine ~84, ORIJEN/ACANA 65-71 in their lowest column), so "Familiehund" uses 95 and the
  // rest scale from it. That keeps foods with and without a table within ~10 % of each other for the same dog.
  // and kcal per kg^0.67 for cats (FEDIAF: 75 indoor/neutered, 100 lean and active)
  var ACT = {
    hund: [
      { id: 'lav', main: 'Rolig', sub: 'Korte ture, under 1 time om dagen', k: 85, adj: 'rolig hverdag' },
      { id: 'normal', main: 'Familiehund', sub: '1-2 timers gåture og leg', k: 95 },
      { id: 'aktiv', main: 'Aktiv', sub: '2-3 timer, løb, cykel eller lange ture', k: 115, adj: 'aktiv hverdag' },
      { id: 'hoj', main: 'Arbejdshund', sub: 'Jagt, agility, træk eller hyrdearbejde', k: 150, adj: 'arbejde og sport' }
    ],
    kat: [
      { id: 'lav', main: 'Indekat', sub: 'Kun inde, sover meget', k: 75, adj: 'indeliv' },
      { id: 'normal', main: 'Legesyg indekat', sub: 'Inde, leger hver dag', k: 85 },
      { id: 'aktiv', main: 'Inde og ude', sub: 'Går ud et par timer', k: 95, adj: 'inde- og udeliv' },
      { id: 'hoj', main: 'Udekat', sub: 'Mest ude, jager mus', k: 110, adj: 'udeliv' }
    ]
  };
  /* Adult energy need (kcal a day). The factors multiply, but with floors, so a stack of choices
     (rolig + senior + kastreret + vægttab) can never take the amount below what the body uses at rest:
     - senior dog (7+ years): -10 % (FEDIAF: older dogs need about 10-15 % less)
     - neutered dog: -10 % (lower metabolism after neutering; studies find 10-30 %)
     - maintenance never below 1.2 x RER for dogs or 1.0 x RER for cats (RER = 70 x kg^0.75)
     - weight loss: 80 % of maintenance at the target weight, never below 1.0 x RER (dogs) or 0.8 x RER (cats)
       at the target weight (AAHA 2014 weight management guidelines) */
  function adultKcal(cat, w, o) {
    var rer = 70 * Math.pow(w, 0.75);
    var kcal = o.act.k * Math.pow(w, cat ? 0.67 : 0.75);
    if (o.senior && !cat) kcal *= 0.9;
    if (o.neut && !cat) kcal *= 0.9;
    var floor = rer * (cat ? 1 : 1.2), floored = kcal < floor;
    kcal = Math.max(kcal, floor);
    if (o.lose) { var lf = rer * (cat ? 0.8 : 1); floored = kcal * 0.8 < lf; kcal = Math.max(kcal * 0.8, lf); }
    return { kcal: kcal, floored: floored };
  }
  function kcalNeed(cat, stage, w, act, age, adult, o) {
    if (stage === 'young') {
      var p = Math.min(1, growShare(cat, adult, age)), bw = Math.max(0.2, adult * p);
      var k = cat ? 100 * Math.pow(bw, 0.67) * 6.7 * (Math.exp(-0.189 * p) - 0.66)
        : (254.1 - 135 * p) * Math.pow(bw, 0.75); // FEDIAF 2021 growth equation for puppies
      return { kcal: k, bw: bw };
    }
    return adultKcal(cat, w, { act: act, senior: stage === 'senior', neut: o && o.neut, lose: o && o.lose });
  }
  var ALLERGY = [['kylling', 'Kylling'], ['okse', 'Okse'], ['fisk', 'Fisk'], ['korn', 'Korn']];
  // Claude fixes 74 (Mads): optional breed and current food. Saved only; they never change the amount.
  var BREEDS = {
    hund: ['Blanding', 'Labrador retriever', 'Golden retriever', 'Schæferhund', 'Fransk bulldog', 'Border collie', 'Siberian husky', 'Gravhund',
      'Chihuahua', 'Cavalier king charles spaniel', 'Alaskan malamute', 'Akita', 'Amerikansk staffordshire terrier', 'Australian shepherd',
      'Basset hound', 'Beagle', 'Belgisk hyrdehund (malinois)', 'Berner sennenhund', 'Bichon frisé', 'Border terrier', 'Boxer', 'Broholmer',
      'Bullterrier', 'Cairn terrier', 'Cane corso', 'Chow chow', 'Cockapoo', 'Collie', 'Coton de tuléar', 'Dalmatiner', 'Dansk-svensk gårdhund',
      'Dobermann', 'Engelsk bulldog', 'Engelsk cocker spaniel', 'Engelsk setter', 'Engelsk springer spaniel', 'Flat coated retriever',
      'Grand danois', 'Grosser münsterländer', 'Grønlandshund', 'Havanese', 'Hollandsk hyrdehund', 'Hvid schweizisk hyrdehund', 'Irsk setter',
      'Irsk ulvehund', 'Islandsk fårehund', 'Jack russell terrier', 'Japansk spids', 'Kleiner münsterländer', 'Kooikerhondje', 'Korthåret hønsehund',
      'Labradoodle', 'Lagotto romagnolo', 'Leonberger', 'Lhasa apso', 'Malteser', 'Mops', 'Newfoundlænder', 'Nova scotia duck tolling retriever',
      'Papillon', 'Parson russell terrier', 'Pointer', 'Pomeranian', 'Puddel', 'Dværgpuddel', 'Toypuddel', 'Rhodesian ridgeback', 'Rottweiler',
      'Ruhåret hønsehund', 'Samojedhund', 'Sankt bernhardshund', 'Schnauzer', 'Dværgschnauzer', 'Riesenschnauzer', 'Shar pei', 'Shetland sheepdog',
      'Shiba', 'Shih tzu', 'Staffordshire bullterrier', 'Tibetansk terrier', 'Vizsla', 'Weimaraner', 'West highland white terrier', 'Whippet',
      'Yorkshire terrier'],
    kat: ['Huskat', 'Blanding', 'Maine coon', 'Norsk skovkat', 'Britisk korthår', 'Britisk langhår', 'Ragdoll', 'Bengal', 'Perser', 'Siameser',
      'Sibirisk kat', 'Hellig birma', 'Abyssinier', 'Russisk blå', 'Scottish fold', 'Sphynx', 'Devon rex', 'Cornish rex', 'Orientalsk korthår',
      'Exotic shorthair', 'Burmeser', 'Tyrkisk angora', 'Savannah']
  };
  var FOODS = ['PLATINUM', 'Profine', 'Royal Canin', "Hill's", 'Purina Pro Plan', 'ACANA', 'ORIJEN', 'Eukanuba', 'Brit', 'Belcando', 'Josera',
    'Wolfsblut', 'Supermarkedets eget mærke', 'Vådfoder/dåsemad', 'BARF/råfoder', 'Hjemmelavet', 'Andet', 'Ved ikke'];
  function cleanBreed(s) { return String(s || '').replace(/\s+/g, ' ').trim().slice(0, 40).trim(); }
  // Claude fixes 75 (breed75): breed autocomplete. Case and accent blind; æ/ae, ø/oe, å/aa count as the same.
  function foldBreed(s) {
    s = String(s || '').toLowerCase().replace(/æ/g, 'ae').replace(/ø/g, 'oe').replace(/å/g, 'aa');
    if (s.normalize) s = s.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    return s.replace(/ae/g, 'a').replace(/oe/g, 'o').replace(/aa/g, 'a').replace(/[^a-z0-9]+/g, ' ').replace(/\s+/g, ' ').trim();
  }
  function matchBreeds(list, q, max) {
    q = foldBreed(q); if (!q) return [];
    var pre = [], mid = [];
    list.forEach(function (b) { var f = foldBreed(b), i = f.indexOf(q); if (i === 0) pre.push(b); else if (i > 0) mid.push(b); });
    return pre.concat(mid).slice(0, max || 6);
  }

  /* ---------- formatting ---------- */
  function fmt(n, d) { return Number(n).toLocaleString('da-DK', { minimumFractionDigits: d || 0, maximumFractionDigits: d || 0 }); }
  function num(v) { return fmt(v, v % 1 ? 1 : 0); }
  function money(cents) { return fmt(cents / 100, 2) + ' kr.'; }
  function round5(g) { return g < 40 ? Math.round(g) : Math.round(g / 5) * 5; }
  function grams(g) { return g >= 1000 ? fmt(g / 1000, 2).replace(/,?0+$/, '') + ' kg' : fmt(round5(g)) + ' g'; }
  function qtyName(q) { return q >= 1000 ? fmt(q / 1000, q % 1000 ? 1 : 0) + ' kg' : fmt(q) + ' g'; }
  function frac(n) { // 2.5 -> "2½"
    var w = Math.floor(n), r = n - w, s = '';
    if (r >= 0.875) { w++; } else if (r >= 0.625) s = '¾'; else if (r >= 0.375) s = '½'; else if (r >= 0.125) s = '¼';
    return (w ? w : (s ? '' : '0')) + s;
  }
  function duration(days) {
    if (days < 13.5) return 'ca. ' + fmt(Math.max(1, Math.floor(days))) + (Math.floor(days) === 1 ? ' dag' : ' dage');
    var w = days / 7;
    if (days < 63) return 'ca. ' + fmt(Math.floor(w * 2) / 2, (Math.floor(w * 2) % 2) ? 1 : 0) + ' uger';
    return 'ca. ' + fmt(Math.floor(days / 30.4 * 2) / 2, (Math.floor(days / 30.4 * 2) % 2) ? 1 : 0) + ' måneder';
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function parseQty(s) {
    s = String(s || '');
    var m = s.match(/(\d+)\s*[x×]\s*(\d+(?:[.,]\d+)?)\s*(kg|g)\b/i);
    if (m) return +m[1] * parseFloat(m[2].replace(',', '.')) * (m[3].toLowerCase() === 'kg' ? 1000 : 1);
    m = s.match(/(\d+(?:[.,]\d+)?)\s*(kg|g)\b/i);
    if (m) return parseFloat(m[1].replace(',', '.')) * (m[2].toLowerCase() === 'kg' ? 1000 : 1);
    return null;
  }
  function animateNum(el, from, to) {
    var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!from || Math.abs(from - to) < 1 || !window.requestAnimationFrame || reduce) { el.textContent = grams(to); return; }
    var t0 = null;
    function step(t) {
      if (!t0) t0 = t;
      var k = Math.min(1, (t - t0) / 260);
      if (!el.isConnected) return;
      el.textContent = grams(from + (to - from) * (1 - Math.pow(1 - k, 3)));
      if (k < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  /* ---------- storage ---------- */
  function load(k) { try { return JSON.parse(localStorage.getItem('fbfc2:' + k) || 'null'); } catch (e) { return null; } }
  function save(k, v) { try { localStorage.setItem('fbfc2:' + k, JSON.stringify(v)); } catch (e) {} }

  /* ---------- usage data (Claude fixes 73, Mads) ----------
     After the visitor has used the calculator: one 'foderberegner_brugt' event per page view per species (never the
     pet's name), and the answers as cart attributes "Foderberegner …", which end up on the order (Yderligere detaljer).
     Shared by all calculators on the page. Never blocks the page: errors are swallowed. */
  function isoDay(add) {
    var d = new Date(); d.setDate(d.getDate() + (add || 0));
    return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2);
  }
  var evSent = {}, attrSent = '', attrPending = null, attrT = null, attrAt = 0;
  // Claude fixes 74: one sender for all events. beacon: the page is closing, so ask gtag to send with sendBeacon
  // (Shopify.analytics.publish and dataLayer have no such option; Shopify's pixels and GTM's own tags handle that).
  function emit(name, ev, beacon) {
    try { if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') Shopify.analytics.publish(name, ev); } catch (e) {}
    try { if (typeof window.gtag === 'function') window.gtag('event', name, beacon ? Object.assign({ transport_type: 'beacon' }, ev) : ev); } catch (e) {}
    try { if (window.dataLayer && typeof window.dataLayer.push === 'function') window.dataLayer.push(Object.assign({ event: name }, ev)); } catch (e) {}
  }
  function publish(ev) { emit('foderberegner_brugt', ev); }
  /* Step tracking (Claude fixes 74, Mads): 'foderberegner_trin' once per step per page view (shared by every calculator
     on the page), and on pagehide one 'foderberegner_forladt' with the furthest step reached, only when the visitor
     interacted and never pressed the calculator's own Læg i kurv. Never the pet's name. */
  var STEPS = ['aabnet', 'dyr_valgt', 'vaegt_indtastet', 'alder_indtastet', 'resultat_vist', 'ekstra_udfyldt', 'laeg_i_kurv', 'forslag_klikket'];
  var stepSent = {}, stepTop = 0, stepTopCtx = null, interacted = false, leftSent = false;
  function trackStep(name, ctx) {
    var n = STEPS.indexOf(name) + 1;
    if (!n || stepSent[name]) return;
    if (name !== 'aabnet') { interacted = true; if (!stepSent.aabnet) trackStep('aabnet', ctx); }
    stepSent[name] = true;
    if (n > stepTop) { stepTop = n; stepTopCtx = ctx; }
    emit('foderberegner_trin', { step: name, step_number: n, species: ctx.species, product: ctx.product, page_type: ctx.page_type });
  }
  window.addEventListener('pagehide', function () {
    if (leftSent || !interacted || stepSent.laeg_i_kurv || !stepTop) return;
    leftSent = true;
    var c = stepTopCtx || {};
    emit('foderberegner_forladt', { step: STEPS[stepTop - 1], step_number: stepTop, species: c.species, product: c.product, page_type: c.page_type }, true);
  });
  // /pages/foderberegner: the Hund/Kat buttons and the food picker sit outside the calculator
  function cpCtx(species) { return { species: species || '', product: '', page_type: 'page' }; }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-fb-cp-animal]');
    if (b) trackStep('dyr_valgt', cpCtx(b.getAttribute('data-fb-cp-animal')));
  });
  document.addEventListener('change', function (e) {
    var s = e.target.closest && e.target.closest('[data-fb-cp-sel]'); if (!s) return;
    var o = s.options[s.selectedIndex];
    trackStep('dyr_valgt', cpCtx(o && o.getAttribute('data-animal')));
  });
  /* Claude fixes 77 (Mads, order #8071): "Foderberegner pose" / "dage" / "forventet tom" come from what is actually in the
     cart for the calculator's product (sum of bag grams x quantity), not from the cheapest-per-day bag, which is now
     "Foderberegner anbefalet pose". The cart is re-read after every successful /cart/add, /cart/change or /cart/update
     the page makes (fetch and XMLHttpRequest are wrapped once, only after the visitor has used the calculator; our own
     /cart/update.js and /cart.js calls bypass the wrapper). Cart lines are never changed here. */
  var attrBase = null, calcCtx = null, cartCache = null, cartBusy = false, cartAgain = false, cartBusyT = null, sendWhenCart = false, cartHooked = false, rawFetch = null;
  function rootUrl() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function ownFetch(url, init) { return (rawFetch || window.fetch).call(window, url, init); }
  function isCartWrite(u) {
    try { return /\/cart\/(add|change|update)(\.js|\.json)?$/.test(new URL(String(u), location.href).pathname); } catch (e) { return false; }
  }
  function isCartAdd(u) { try { return /\/cart\/add(\.js|\.json)?$/.test(new URL(String(u), location.href).pathname); } catch (e) { return false; } }
  function isCart(j) { return j && typeof j === 'object' && Array.isArray(j.items) && 'item_count' in j; }
  // the lines an add request asked for (JSON items, a single id, FormData, URLSearchParams or a urlencoded string)
  function addedLines(body) {
    var out = [];
    function one(id, q, plan) { id = +id; if (id) out.push({ variant_id: id, quantity: Math.max(1, +q || 1), selling_plan_allocation: +plan ? { selling_plan: { id: +plan } } : null }); }
    function fromParams(p) { if (p.get('id')) one(p.get('id'), p.get('quantity'), p.get('selling_plan')); }
    try {
      if (!body) return out;
      if (typeof body === 'string') {
        var j = null; try { j = JSON.parse(body); } catch (e) {}
        if (j && j.items && j.items.forEach) j.items.forEach(function (it) { one(it.id, it.quantity, it.selling_plan); });
        else if (j && j.id) one(j.id, j.quantity, j.selling_plan);
        else if (!j) fromParams(new URLSearchParams(body));
      } else if ((window.FormData && body instanceof FormData) || (window.URLSearchParams && body instanceof URLSearchParams)) fromParams(body);
    } catch (e) {}
    return out;
  }
  function planOf(l) { var a = l.selling_plan_allocation; return a && a.selling_plan ? +a.selling_plan.id || 1 : 0; }
  // put an add into the cached cart at once (the real cart is read right after); so a quick checkout still flushes it
  function predictAdd(lines) {
    if (!lines.length) return;
    var items = cartCache && cartCache.items ? cartCache.items.slice() : [];
    lines.forEach(function (n) {
      var hit = null;
      items.forEach(function (it, i) { if (!hit && +it.variant_id === n.variant_id && planOf(it) === planOf(n)) hit = i; });
      if (hit !== null) items[hit] = Object.assign({}, items[hit], { quantity: (+items[hit].quantity || 0) + n.quantity });
      else items.push(n);
    });
    cartCache = { items: items, item_count: 0, predicted: true };
  }
  function cartAttrs() {
    var r = { pose: '', dage: '', tom: '' }, c = calcCtx;
    if (!c || !cartCache || !cartCache.items) return r;
    var total = 0, parts = [], seen = {};
    cartCache.items.forEach(function (l) {
      var id = +l.variant_id, s = c.byId[id];
      if (!s && !(c.handle && l.handle === c.handle)) return;
      var q = Math.max(0, +l.quantity || 0); if (!q) return;
      var t = s ? s.title : (l.variant_title || ''), gr = s ? s.grams : (parseQty(l.variant_title) || parseQty(l.title) || 0);
      total += gr * q;
      // "3x 5kg" stays as the variant is called; a plain bag is written like the size cards ("1,5 kg")
      var lab = t && /\d\s*[x×]\s*\d/i.test(t) ? t.trim() : gr ? qtyName(gr) : t.trim() || '?', sub = planOf(l) ? 1 : 0, k = lab + '|' + sub;
      if (seen[k] === undefined) { seen[k] = parts.length; parts.push({ lab: lab, sub: sub, q: 0 }); }
      parts[seen[k]].q += q;
    });
    if (!parts.length) return r;
    r.pose = parts.map(function (p) { return p.lab + ' × ' + p.q + (p.sub ? ' (fast levering)' : ''); }).join(', ');
    if (c.gpd && total) { var d = Math.floor(total / c.gpd); r.dage = String(d); r.tom = isoDay(d); }
    return r;
  }
  function composeAttrs() {
    var a = Object.assign({}, attrBase), c = cartAttrs(), P = 'Foderberegner ';
    a[P + 'pose'] = c.pose; a[P + 'dage'] = c.dage; a[P + 'forventet tom'] = c.tom;
    return a;
  }
  function loadCart() {
    if (cartBusy) { cartAgain = true; return; }
    cartBusy = true; cartAgain = false;
    clearTimeout(cartBusyT); cartBusyT = setTimeout(cartDone, 4000); // never wait for ever on a hanging request
    try {
      ownFetch(rootUrl() + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) { if (isCart(j)) cartCache = j; cartDone(); }, cartDone);
    } catch (e) { cartDone(); }
  }
  function cartDone() {
    clearTimeout(cartBusyT); cartBusyT = null;
    if (!cartBusy) return;
    cartBusy = false;
    if (cartAgain) { loadCart(); return; }
    if (attrBase && !attrPending) queueAttrs(); // keep a running debounce as it is
    if (sendWhenCart) { sendWhenCart = false; sendAttrs(); }
  }
  var cartChgT = null;
  function cartChanged(cart, added) {
    if (!attrBase) return;
    if (isCart(cart)) cartCache = cart; else predictAdd(added || []);
    queueAttrs();
    clearTimeout(cartChgT);
    if (!isCart(cart)) cartChgT = setTimeout(loadCart, 150); // an add answers with the line only: read the real cart
  }
  function hookCart() {
    if (cartHooked) return; cartHooked = true;
    try {
      var f = window.fetch;
      if (typeof f === 'function' && !f.fbfcWrap) {
        rawFetch = f;
        var w = function (input, init) {
          var p = f.apply(window, arguments);
          try {
            var u = typeof input === 'string' ? input : input && input.url;
            if (u && isCartWrite(u) && p && p.then) {
              var add = isCartAdd(u), body = init && init.body;
              p.then(function (r) {
                if (!r || !r.ok) return;
                if (add) { cartChanged(null, addedLines(body)); return; }
                var c = null; try { c = r.clone(); } catch (e) {}
                if (!c) { cartChanged(null, []); return; }
                c.json().then(function (j) { cartChanged(j, []); }, function () { cartChanged(null, []); });
              }, function () {});
            }
          } catch (e) {}
          return p;
        };
        w.fbfcWrap = true;
        window.fetch = w;
      }
    } catch (e) {}
    try {
      var XP = window.XMLHttpRequest && XMLHttpRequest.prototype;
      if (XP && !XP.fbfcWrap) {
        XP.fbfcWrap = true;
        var o = XP.open, s = XP.send;
        XP.open = function (m, u) { try { this.fbfcCart = isCartWrite(u) ? (isCartAdd(u) ? 'add' : 'chg') : ''; } catch (e) {} return o.apply(this, arguments); };
        XP.send = function (body) {
          try {
            var x = this, kind = x.fbfcCart;
            if (kind) x.addEventListener('load', function () {
              if (x.status < 200 || x.status >= 300) return;
              if (kind === 'add') { cartChanged(null, addedLines(body)); return; }
              var j = null; try { if (!x.responseType || x.responseType === 'text') j = JSON.parse(x.responseText); else if (x.responseType === 'json') j = x.response; } catch (e) {}
              cartChanged(j, []);
            });
          } catch (e) {}
          return s.apply(this, arguments);
        };
      }
    } catch (e) {}
    // a plain (non-AJAX) form post to /cart/add leaves the page: count it before pagehide flushes
    document.addEventListener('submit', function (e) {
      try {
        var f = e.target;
        if (e.defaultPrevented || !f || !/\/cart\/add/.test(f.getAttribute('action') || '')) return;
        cartChanged(null, addedLines(new FormData(f)));
      } catch (x) {}
    });
  }
  function sendAttrs(keepalive) {
    clearTimeout(attrT); attrT = null;
    if (!attrPending || !attrBase) return;
    if (cartBusy && !keepalive && !cartCache) { sendWhenCart = true; return; }
    var body = JSON.stringify({ attributes: composeAttrs() }); attrPending = null;
    if (body === attrSent) return;
    attrSent = body; attrAt = Date.now();
    try {
      ownFetch(rootUrl() + 'cart/update.js', { method: 'POST', keepalive: !!keepalive, headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: body })
        .then(function (r) { if (!r.ok) attrSent = ''; }, function () { attrSent = ''; });
    } catch (e) { attrSent = ''; }
  }
  function queueAttrs(a) { // 3 s after the last change, and at most every 5 s
    if (a) {
      attrBase = a;
      if (!cartHooked) { hookCart(); loadCart(); }
    }
    attrPending = true; clearTimeout(attrT);
    attrT = setTimeout(sendAttrs, Math.max(3000, attrAt + 5000 - Date.now()));
  }
  window.addEventListener('pagehide', function () { if (attrPending) sendAttrs(true); });

  var ICON = {
    lav: '<path d="M20 14.5A8 8 0 1 1 9.5 4a6.5 6.5 0 0 0 10.5 10.5z"/>',
    normal: '<circle cx="13" cy="4.5" r="1.8"/><path d="M11 21l2-6-2.5-2.5L12 8l3 3 3 1M8 13l2.5-5"/>',
    aktiv: '<circle cx="15" cy="4.5" r="1.8"/><path d="M6 20l4-4 2 1.5 1-4.5M9 10l3-2 3 2.5 3 .5M13 13l3 3v4"/>',
    hoj: '<path d="M13 2L4 14h7l-1 8 9-12h-7z"/>'
  };
  function ico(id) { return '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + (ICON[id] || ICON.normal) + '</svg>'; }

  /* ---------- widget ---------- */
  function init(root) {
    var dataEl = root.querySelector('[data-fbfc-data]');
    if (!dataEl) return;
    var data; try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var g = data.guide && data.guide.columns && data.guide.rows ? data.guide : null;
    var c0 = g ? String(g.columns[0]).toLowerCase() : '';
    var kind = !g ? null : c0.indexOf('voksenvægt') > -1 ? 'puppy' : c0.indexOf('alder') > -1 ? 'age' : c0.indexOf('vægt') > -1 ? 'weight' : null;
    var cat = data.animal === 'kat' || /katte|killing/.test(c0);
    var sp = cat ? 'kat' : 'hund';
    var ptxt = ((data.title || '') + ' ' + (data.feedType || '')).toLowerCase();
    var wet = /vådfoder|dåse|pate|pâté|bakke|pølse/i.test((data.type || '') + ' ' + (data.title || ''));
    var pStage = /puppy|hvalp|junior|kitten|killing/.test(ptxt) || kind === 'puppy' || kind === 'age' ? 'young'
      : /senior|ældre/.test(ptxt) ? 'senior' : /alle livsstadier|all life/.test(ptxt) ? 'all' : 'adult';
    var pSize = /small.?\/.?medium/.test(ptxt) ? 'smallmed' : /small|mini\b/.test(ptxt) ? 'small' : /large|maxi|giant/.test(ptxt) ? 'large' : 'all';
    var meta = ' ' + (data.meta || '') + ' ';
    var has = {}; ALLERGY.forEach(function (x) { has[x[0]] = meta.indexOf(' c-' + x[0] + ' ') > -1; });
    var hasKnown = meta.indexOf(' c-x ') < 0 && /\S/.test(data.meta || '');
    var isSens = meta.indexOf(' sens ') > -1, isLight = /light|fit|trim|vægttab|sterili[sz]ed/i.test(ptxt);
    var mMin = +((meta.match(/ min-(\d+) /) || [])[1] || 0), mMax = +((meta.match(/ max-(\d+) /) || [])[1] || 0);
    if (!mMin && pSize === 'large') mMin = 25;
    if (!mMax && pSize === 'small') mMax = 10;
    if (!mMax && pSize === 'smallmed') mMax = 25;
    var tableYoungWeight = kind === 'weight' && /hvalp|killing/.test(c0); // table by the puppy's current weight
    var kcalKg = parseEnergy(data.energy), kcalSrc = kcalKg ? 'energy' : null;
    if (!kcalKg) { kcalKg = atwater(data.ac, wet); if (kcalKg) kcalSrc = 'atwater'; }
    if (kcalKg && (kcalKg < 400 || kcalKg > 5600)) kcalKg = null;
    if (/tilskud/i.test(data.feedType || '')) kcalKg = null; // complementary feed: never estimate a full ration

    var who = { hund: { young: 'hvalp', adult: 'hund', senior: 'hund' }, kat: { young: 'killing', adult: 'kat', senior: 'kat' } }[sp];
    var store = load(sp) || {};

    // sizes from the server-rendered cards
    var sizes = Array.prototype.map.call(root.querySelectorAll('[data-fbfc-size]'), function (el) {
      var q = parseFloat(el.getAttribute('data-qty')) || 0, u = (el.getAttribute('data-qty-unit') || '').toLowerCase();
      if (q && (u === 'kg' || u === 'l')) q *= 1000;
      if (!q) q = parseQty(el.getAttribute('data-title')) || parseQty(data.title);
      return { el: el, grams: q, price: +el.getAttribute('data-price'), available: el.getAttribute('data-available') === 'true' };
    }).filter(function (s) { if (!s.grams) { s.el.hidden = true; return false; } return true; });
    var packGrams = sizes.length ? Math.min.apply(null, sizes.map(function (s) { return s.grams; })) : 0;
    var unitWord = /bakke/i.test((g && g.note) || '') ? 'bakker' : /dåse/i.test((g ? g.columns.join(' ') : '') + (data.title || '')) ? 'dåser' : /pose/i.test(data.title || '') ? 'poser' : 'stk.';
    var unitOne = { bakker: 'bakke', 'dåser': 'dåse', poser: 'pose' }[unitWord] || unitWord;
    sizes.forEach(function (s) {
      var nEl = s.el.querySelector('[data-fbfc-name]'); if (!nEl) return;
      var t = s.el.getAttribute('data-title') || '';
      nEl.textContent = /^default title$/i.test(t) || !t ? qtyName(s.grams)
        : t.replace(/(\d)\s*[x×]\s*/i, '$1 × ').replace(/(\d)\.(\d)/g, '$1,$2').replace(/(\d)\s*(kg|g)\b/gi, '$1 $2');
    });

    // manufacturer table: modes (columns) and curves
    var unitGrams = null, modes = [], ages = [];
    if (kind === 'puppy') {
      ages = g.columns.slice(1).map(function (c, i) { return { i: i + 1, ax: parseAxis(c), label: c }; }).filter(function (a) { return a.ax; });
      var pointsOnly = ages.every(function (a) { return a.ax.lo === a.ax.hi; });
      ages.forEach(function (a, k) {
        if (pointsOnly) {
          var p = a.ax.lo, prev = k ? ages[k - 1].ax.lo : null, next = k < ages.length - 1 ? ages[k + 1].ax.lo : null;
          a.from = prev === null ? 0 : (prev + p) / 2; a.to = next === null ? p + (p - (prev || 0)) / 2 : (p + next) / 2;
        } else { a.from = /op til/i.test(a.label) ? 0 : a.ax.lo; a.to = a.ax.hi; }
        a.curve = curve(g.rows.map(function (r) { return [r[0], r[a.i]]; }));
      });
      if (!ages.length) kind = null;
    } else if (kind) {
      var um = g.columns[1] && g.columns[1].match(/(dåse|bakke|pose)r?\s*\((\d+)\s*g\)/i);
      if (um) unitGrams = +um[2];
      g.columns.slice(1).forEach(function (c, i) {
        modes.push({ label: modeLabel(c) || { main: c, sub: '' }, curve: curve(g.rows.map(function (r) { return [r[0], r[i + 1]]; }), unitGrams) });
      });
      modes = modes.filter(function (mo) { return mo.curve.min || mo.curve.max || mo.curve.texts.length; });
      if (!modes.length) kind = null;
    }
    if (!kind && !kcalKg) { root.hidden = true; return; }
    var mode = 0;
    for (var mi = 0; mi < modes.length; mi++) { if (!/vægttab|overvægt|ekstrem/i.test(modes[mi].label.main + ' ' + modes[mi].label.sub)) { mode = mi; break; } }
    var makerModes = modes.length > 1;

    /* ---------- state ---------- */
    var acts = ACT[sp];
    // Ages offered (months): every month to 1 year, then half a year to 2 years, then whole years
    var AGES = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 18, 24];
    for (var yy = 3; yy <= (cat ? 22 : 18); yy++) AGES.push(yy * 12);
    var juniorMax = kind === 'puppy' && ages.length ? ages[ages.length - 1].to : 0; // e.g. Junior Large tables run to 24 months
    var defAge = pStage === 'young' ? 4 : pStage === 'senior' ? (cat ? 144 : 96) : 36;
    var state = {
      name: store.name || '',
      weight: store.weight || (cat ? 4 : 20),
      adult: store.adult || (cat ? 4.5 : 20),
      age: store.age || defAge,
      act: store.act || 'normal',
      neut: !!store.neut,
      lose: !!store.lose,
      alg: !!store.alg,
      sens: !!store.sens,
      avoid: (store.avoid || []).filter(function (x) { return ALLERGY.some(function (y) { return y[0] === x; }); }),
      breed: cleanBreed(store.breed),
      food: FOODS.indexOf(store.food) > -1 ? store.food : '',
      stage: 'adult'
    };
    if (!acts.some(function (a) { return a.id === state.act; })) state.act = 'normal';
    function syncStage() {
      var young = state.age < Math.max(12, adultAgeDone(cat, state.adult)) || (juniorMax > 12 && state.age < juniorMax && pStage === 'young');
      state.stage = young ? 'young' : state.age >= (cat ? 132 : 84) ? 'senior' : 'adult';
    }
    syncStage();
    var uid = root.id || ('fbfc' + Math.random().toString(36).slice(2, 7));
    var inputs = root.querySelector('[data-fbfc-inputs]');
    var spec = {
      weight: { min: cat ? 0.5 : 1, max: cat ? 12 : 90, step: 0.1 },
      adult: { min: cat ? 2 : 1, max: cat ? 10 : 90, step: 0.5 }
    };
    function ageIdx(m) { var bi = 0; AGES.forEach(function (v, i) { if (Math.abs(v - m) < Math.abs(AGES[bi] - m)) bi = i; }); return bi; }
    function ageText(m) {
      if (m < 12) return { v: String(m), u: m === 1 ? 'måned' : 'måneder' };
      var y = m / 12;
      return { v: (y % 1 ? fmt(Math.floor(y)) + '½' : fmt(y)), u: 'år' };
    }

    function stepper(key, label, unit, hint) {
      var s = spec[key];
      return '<div class="fbfc__field" data-fbfc-f="' + key + '"><div class="fbfc__lbl"><label for="' + uid + '-' + key + '" data-fbfc-l="' + key + '">' + label + '</label>' + (hint ? '<span class="fbfc__hint" data-fbfc-hint="' + key + '">' + hint + '</span>' : '') + '</div>' +
        '<div class="fbfc__stepper"><button type="button" class="fbfc__step" data-step="-1" data-for="' + key + '" aria-label="Mindre">−</button>' +
        '<div class="fbfc__val"><input id="' + uid + '-' + key + '" type="text" inputmode="decimal" autocomplete="off" data-k="' + key + '"><span data-fbfc-u="' + key + '">' + unit + '</span></div>' +
        '<button type="button" class="fbfc__step" data-step="1" data-for="' + key + '" aria-label="Mere">+</button></div>' +
        '<input class="fbfc__range" type="range" min="' + (s ? s.min : 0) + '" max="' + (s ? s.max : AGES.length - 1) + '" step="' + (s ? s.step : 1) + '" data-k="' + key + '" aria-label="' + label + '"></div>';
    }
    function renderInputs() {
      var Who = cat ? 'Kattens' : 'Hundens';
      var h = '<div class="fbfc__field fbfc__field--name"><label for="' + uid + '-n">' + Who + ' navn <span class="fbfc__opt">(valgfrit)</span></label>' +
        '<input id="' + uid + '-n" type="text" maxlength="24" autocomplete="off" placeholder="Fx ' + (cat ? 'Misser' : 'Carl') + '" value="' + esc(state.name) + '" data-k="name"></div>';
      h += stepper('age', 'Alder', 'år', '');
      h += stepper('weight', Who + ' vægt', 'kg', 'Overvægtig? Se nedenfor');
      h += stepper('adult', 'Forventet vægt som voksen', 'kg', cat ? 'De fleste katte vejer 3,5-5 kg' : 'Spørg opdrætteren, eller se racens typiske vægt');
      if (makerModes && kind === 'weight') {
        h += '<div class="fbfc__field" data-fbfc-f="modes"><div class="fbfc__lbl"><span id="' + uid + '-ml">Producentens valg</span><span class="fbfc__hint">Vælg det, der passer bedst</span></div><div class="fbfc__chips" role="radiogroup" aria-labelledby="' + uid + '-ml">';
        modes.forEach(function (mo, i) {
          h += '<button type="button" class="fbfc__chip" role="radio" data-mode="' + i + '" aria-checked="' + (i === mode) + '"><b>' + esc(mo.label.main) + '</b>' + (mo.label.sub ? '<small>' + esc(mo.label.sub) + '</small>' : '') + '</button>';
        });
        h += '</div></div>';
      } else {
        h += '<div class="fbfc__field" data-fbfc-f="acts"><div class="fbfc__lbl"><span id="' + uid + '-al">Hverdag og motion</span></div><div class="fbfc__acts" role="radiogroup" aria-labelledby="' + uid + '-al">';
        acts.forEach(function (a) {
          h += '<button type="button" class="fbfc__act" role="radio" data-act="' + a.id + '" aria-checked="' + (a.id === state.act) + '">' + ico(a.id) + '<b>' + a.main + '</b><small>' + a.sub + '</small></button>';
        });
        h += '</div></div>';
      }
      function tog(k, label) { return '<button type="button" class="fbfc__tog" role="switch" data-tog="' + k + '" data-fbfc-t="' + k + '" aria-checked="' + state[k] + '"><span class="fbfc__tog-box" aria-hidden="true"></span>' + label + '</button>'; }
      h += '<div class="fbfc__toggles" data-fbfc-f="toggles">' + (cat ? '' : tog('neut', 'Kastreret')) + tog('lose', 'Skal tabe sig') + tog('alg', 'Allergi / sensitiv') + '</div>';
      h += '<div class="fbfc__field" data-fbfc-f="avoid"><div class="fbfc__lbl"><span id="' + uid + '-av">Hvad reagerer ' + (cat ? 'katten' : 'hunden') + ' på?</span><span class="fbfc__hint">Vælg gerne flere</span></div><div class="fbfc__chips fbfc__chips--sm" role="group" aria-labelledby="' + uid + '-av">' +
        '<button type="button" class="fbfc__chip fbfc__chip--wide" data-sens aria-pressed="' + state.sens + '"><b>Bare sensitiv</b><small>Mave eller hud, uden kendt allergi</small></button>' +
        ALLERGY.map(function (x) { return '<button type="button" class="fbfc__chip" data-avoid="' + x[0] + '" aria-pressed="' + (state.avoid.indexOf(x[0]) > -1) + '"><b>' + x[1] + '</b></button>'; }).join('') + '</div></div>';
      // Claude fixes 74: optional extras, collapsed to one short row so the calculator is not taller
      h += '<details class="fbfc__more" data-fbfc-f="more"><summary class="fbfc__more-sum"><span class="fbfc__more-plus" aria-hidden="true"></span><span class="fbfc__more-ttl">Fortæl os lidt mere <span class="fbfc__opt">(valgfrit)</span></span><span class="fbfc__more-val" data-fbfc-more-val></span></summary>' +
        '<div class="fbfc__more-body"><div class="fbfc__field fbfc__field--name"><label for="' + uid + '-race">Race <span class="fbfc__opt">(valgfri)</span></label>' +
        // Claude fixes 75 (breed75): own autocomplete instead of <datalist> (Safari showed the whole list, unfiltered, with an arrow)
        '<div class="fbfc__ac"><input id="' + uid + '-race" type="text" maxlength="40" autocomplete="off" autocorrect="off" spellcheck="false" role="combobox" aria-autocomplete="list" aria-expanded="false" aria-controls="' + uid + '-races" placeholder="Fx ' + (cat ? 'Huskat' : 'Labrador retriever') + '" value="' + esc(state.breed) + '" data-x="breed">' +
        '<ul id="' + uid + '-races" class="fbfc__ac-list" role="listbox" aria-label="Racer" hidden></ul></div></div>' +
        '<div class="fbfc__field fbfc__field--name"><label for="' + uid + '-food">Hvad fodrer du med nu?</label>' +
        '<select id="' + uid + '-food" class="fbfc__more-sel" data-x="food"><option value="">Vælg (valgfrit)</option>' +
        FOODS.map(function (f) { return '<option value="' + esc(f) + '"' + (f === state.food ? ' selected' : '') + '>' + esc(f) + '</option>'; }).join('') + '</select></div></div></details>';
      inputs.innerHTML = h;
      moreVal();
      Object.keys(spec).forEach(function (k) { setVal(k, state[k]); });
      setAge(state.age);
    }
    function fieldsForStage() {
      var young = state.stage === 'young';
      var show = { weight: !young, adult: young && !(cat && kind === 'age'), acts: !young, modes: !young, avoid: state.alg };
      Object.keys(show).forEach(function (k) { var el = inputs.querySelector('[data-fbfc-f="' + k + '"]'); if (el) el.hidden = !show[k]; });
      ['neut', 'lose'].forEach(function (k) { var el = inputs.querySelector('[data-fbfc-t="' + k + '"]'); if (el) el.hidden = young; });
      var target = state.lose || (kind === 'weight' && /målvægt/.test(c0));
      var wl = inputs.querySelector('[data-fbfc-l="weight"]'), wh = inputs.querySelector('[data-fbfc-hint="weight"]');
      if (wl) wl.textContent = (cat ? 'Kattens' : 'Hundens') + (target ? ' målvægt' : ' vægt');
      if (wh) wh.textContent = target ? 'Den vægt, den skal ned på' : 'Overvægtig? Se nedenfor';
    }

    function setVal(k, v, from) {
      var s = spec[k]; if (!s) return;
      v = Math.round(Math.min(s.max, Math.max(s.min, v)) / s.step) * s.step;
      v = Math.round(v * 10) / 10;
      state[k] = v;
      root.querySelectorAll('[data-k="' + k + '"]').forEach(function (el) {
        if (el === from) return;
        el.value = el.type === 'range' ? v : num(v);
      });
      var r = root.querySelector('input[type=range][data-k="' + k + '"]');
      if (r) r.style.setProperty('--p', ((v - s.min) / (s.max - s.min) * 100) + '%');
    }
    function setAge(m, from) {
      var i = ageIdx(m); state.age = AGES[i];
      var t = ageText(state.age);
      var inp = inputs.querySelector('input[type=text][data-k="age"]'), u = inputs.querySelector('[data-fbfc-u="age"]'), r = inputs.querySelector('input[type=range][data-k="age"]');
      if (inp && inp !== from) inp.value = t.v;
      if (u) u.textContent = t.u;
      if (r) { if (r !== from) r.value = i; r.style.setProperty('--p', (i / (AGES.length - 1) * 100) + '%'); }
      syncStage(); fieldsForStage();
    }

    var touched = false, ownInput = !!(store.weight || store.age);
    // Claude fixes 74: steps for this calculator (see trackStep)
    function trin(name) { trackStep(name, { species: sp, product: data.handle || '', page_type: pageType }); }
    function moreVal() { // the filled-in extras, shown in the collapsed row
      var el = inputs.querySelector('[data-fbfc-more-val]'); if (!el) return;
      el.textContent = [state.breed, state.food].filter(Boolean).join(' · ');
    }
    inputs.addEventListener('input', function (e) {
      var x = e.target.getAttribute('data-x');
      if (x !== 'breed') return;
      touched = true; trin('dyr_valgt'); state.breed = cleanBreed(e.target.value); moreVal(); update();
      // picked from the list: counts as filled in at once (typed text counts when the field is left)
      var lb = state.breed.toLowerCase();
      if (lb && BREEDS[sp].some(function (b) { return b.toLowerCase() === lb; })) trin('ekstra_udfyldt');
    });
    // Claude fixes 75 (breed75): the breed suggestion list (combobox + listbox). Picking puts the name in the field
    // and fires the same 'input' event as typing, so state, saving, cart attributes and steps are unchanged.
    var acI = -1, acItems = [], acPicking = false, acDown = 0;
    function acEls() { return { inp: inputs.querySelector('input[data-x="breed"]'), ul: inputs.querySelector('.fbfc__ac-list') }; }
    function acClose() {
      var a = acEls(); if (!a.ul) return;
      a.ul.hidden = true; a.ul.innerHTML = ''; acItems = []; acI = -1;
      a.inp.setAttribute('aria-expanded', 'false'); a.inp.removeAttribute('aria-activedescendant');
      a.ul.parentNode.classList.remove('is-up');
    }
    function acMark(i) {
      var a = acEls(); acI = i;
      [].forEach.call(a.ul.children, function (li, j) { li.setAttribute('aria-selected', j === i ? 'true' : 'false'); });
      if (i > -1) a.inp.setAttribute('aria-activedescendant', a.ul.children[i].id); else a.inp.removeAttribute('aria-activedescendant');
    }
    function acOpen() {
      var a = acEls(); if (!a.inp || !a.ul) return;
      acItems = matchBreeds(BREEDS[sp], a.inp.value, 6);
      if (!acItems.length) return acClose();
      a.ul.innerHTML = acItems.map(function (b, i) { return '<li id="' + uid + '-race-o' + i + '" class="fbfc__ac-opt" role="option" aria-selected="false" data-ac="' + i + '">' + esc(b) + '</li>'; }).join('');
      a.ul.hidden = false; a.inp.setAttribute('aria-expanded', 'true'); acI = -1;
      // the card clips its content: open upwards when there is no room below inside it
      var w = a.ul.parentNode; w.classList.remove('is-up');
      var rr = root.getBoundingClientRect(), ir = a.inp.getBoundingClientRect(), h = a.ul.offsetHeight + 6;
      if (ir.bottom + h > rr.bottom && ir.top - h >= rr.top) w.classList.add('is-up');
    }
    function acPick(i) {
      var a = acEls(), b = acItems[i]; if (!b || !a.inp) return;
      a.inp.value = b; acPicking = true;
      try { a.inp.dispatchEvent(new Event('input', { bubbles: true })); } catch (er) { var ev = document.createEvent('Event'); ev.initEvent('input', true, true); a.inp.dispatchEvent(ev); }
      acPicking = false; acClose();
    }
    inputs.addEventListener('input', function (e) { if (e.target.getAttribute('data-x') === 'breed' && !acPicking) acOpen(); });
    inputs.addEventListener('keydown', function (e) {
      if (e.target.getAttribute('data-x') !== 'breed') return;
      var k = e.key, n = acItems.length;
      if (k === 'ArrowDown' || k === 'Down') { if (!n) acOpen(); else acMark((acI + 1) % n); if (acItems.length) e.preventDefault(); }
      else if (k === 'ArrowUp' || k === 'Up') { if (n) { acMark(acI < 1 ? n - 1 : acI - 1); e.preventDefault(); } }
      else if (k === 'Enter') { if (n && acI > -1) { e.preventDefault(); acPick(acI); } else if (n) acClose(); }
      else if (k === 'Escape' || k === 'Esc') { if (n) { e.preventDefault(); e.stopPropagation(); acClose(); } }
      else if (k === 'Tab') acClose();
    });
    // pointerdown/mousedown keep the focus in the field, so blur cannot close the list before the tap counts (iOS, Android)
    function acHold(e) { if (e.target.closest && e.target.closest('.fbfc__ac-list')) { e.preventDefault(); acDown = Date.now(); } }
    inputs.addEventListener('pointerdown', acHold);
    inputs.addEventListener('mousedown', acHold);
    inputs.addEventListener('click', function (e) {
      var li = e.target.closest && e.target.closest('[data-ac]'); if (!li || !inputs.contains(li)) return;
      acDown = 0; acPick(+li.getAttribute('data-ac'));
    });
    inputs.addEventListener('mouseover', function (e) {
      var li = e.target.closest && e.target.closest('[data-ac]'); if (li) acMark(+li.getAttribute('data-ac'));
    });
    inputs.addEventListener('focusout', function (e) { if (e.target.getAttribute('data-x') === 'breed') setTimeout(function () { if (document.activeElement !== e.target && Date.now() - acDown > 1000) acClose(); }, 0); });
    document.addEventListener('pointerdown', function (e) { if (acItems.length && !(e.target.closest && e.target.closest('.fbfc__ac') && root.contains(e.target))) acClose(); }, true);
    inputs.addEventListener('change', function (e) {
      var x = e.target.getAttribute('data-x'); if (!x) return;
      touched = true; trin('dyr_valgt');
      if (x === 'breed') state.breed = cleanBreed(e.target.value); else if (x === 'food') state.food = FOODS.indexOf(e.target.value) > -1 ? e.target.value : '';
      moreVal(); update();
      if (state.breed || state.food) trin('ekstra_udfyldt');
    });
    inputs.addEventListener('input', function (e) {
      var k = e.target.getAttribute('data-k'); if (!k) return;
      touched = true; trin('dyr_valgt');
      if (k === 'age') { ownInput = true; trin('alder_indtastet'); } else if (k === 'weight' || k === 'adult') { ownInput = true; trin('vaegt_indtastet'); }
      if (k === 'name') { state.name = e.target.value.trim(); }
      else if (k === 'age') {
        if (e.target.type === 'range') setAge(AGES[+e.target.value], e.target);
        else {
          var av = parseFloat(String(e.target.value).replace(',', '.').replace('½', '.5')); if (isNaN(av)) return;
          var unitNow = (inputs.querySelector('[data-fbfc-u="age"]') || {}).textContent || 'år';
          setAge(unitNow === 'år' && av < 30 ? av * 12 : av, e.target);
        }
      }
      else { var v = parseFloat(String(e.target.value).replace(',', '.')); if (isNaN(v)) return; setVal(k, v, e.target.type === 'range' ? null : e.target); if (k === 'adult') { syncStage(); fieldsForStage(); } }
      update();
    });
    inputs.addEventListener('change', function (e) {
      var k = e.target.getAttribute('data-k'); if (!k || k === 'name') return;
      if (k === 'age') setAge(state.age); else setVal(k, state[k]);
      update();
    });
    inputs.addEventListener('click', function (e) {
      var b = e.target.closest('[data-step]');
      if (b) {
        touched = true; trin('dyr_valgt');
        var k = b.getAttribute('data-for'), dir = +b.getAttribute('data-step');
        ownInput = true; trin(k === 'age' ? 'alder_indtastet' : 'vaegt_indtastet');
        if (k === 'age') setAge(AGES[Math.max(0, Math.min(AGES.length - 1, ageIdx(state.age) + dir))]);
        else setVal(k, state[k] + dir * (state[k] < 10 ? 0.5 : 1));
        update(); return;
      }
      var tg = e.target.closest('[data-tog]');
      if (tg) {
        touched = true; trin('dyr_valgt'); var key = tg.getAttribute('data-tog'); state[key] = !state[key];
        tg.setAttribute('aria-checked', String(state[key])); fieldsForStage(); update(); return;
      }
      var sv = e.target.closest('[data-sens]');
      if (sv) { touched = true; trin('dyr_valgt'); state.sens = !state.sens; sv.setAttribute('aria-pressed', String(state.sens)); update(); return; }
      var av = e.target.closest('[data-avoid]');
      if (av) {
        touched = true; trin('dyr_valgt'); var al = av.getAttribute('data-avoid'), ix = state.avoid.indexOf(al);
        if (ix > -1) state.avoid.splice(ix, 1); else state.avoid.push(al);
        av.setAttribute('aria-pressed', String(ix < 0)); update(); return;
      }
      var a = e.target.closest('[data-act]');
      if (a) {
        touched = true; trin('dyr_valgt'); state.act = a.getAttribute('data-act');
        root.querySelectorAll('[data-act]').forEach(function (x) { x.setAttribute('aria-checked', String(x.getAttribute('data-act') === state.act)); });
        update(); return;
      }
      var c = e.target.closest('[data-mode]');
      if (c) {
        touched = true; trin('dyr_valgt'); mode = +c.getAttribute('data-mode');
        root.querySelectorAll('[data-mode]').forEach(function (x) { x.setAttribute('aria-checked', String(+x.getAttribute('data-mode') === mode)); });
        update();
      }
    });

    /* ---------- compute ---------- */
    var resultEl = root.querySelector('[data-fbfc-result]');
    var teaser = root.querySelector('[data-fbfc-teaser]');
    var sizesWrap = root.querySelector('[data-fbfc-sizes-wrap]');
    var planEl = root.querySelector('[data-fbfc-plan]');
    var noteEl = root.querySelector('[data-fbfc-note]');
    var altsWrap = root.querySelector('[data-fbfc-alts]');
    var altCards = altsWrap ? Array.prototype.slice.call(altsWrap.querySelectorAll('[data-fbfc-alt]')) : [];
    var altHead = altsWrap ? altsWrap.querySelector('[data-fbfc-alts-h]') : null;
    var srcEl = root.querySelector('[data-fbfc-src]');
    var origTeaser = teaser ? teaser.textContent : '';
    var lastMid = 0;
    function hasAlt(tag) { return altCards.some(function (c) { return (' ' + c.getAttribute('data-fbfc-alt') + ' ').indexOf(' ' + tag + ' ') > -1; }); }
    function list(a) { return a.length < 2 ? a.join('') : a.slice(0, -1).join(', ') + ' og ' + a[a.length - 1]; }
    function reasons(base) { // what we adjusted for, in words (base = what the maker's table already covers)
      if (state.stage === 'young') return [];
      var r = [], a = actObj();
      if (a.adj && !(base && makerModes)) r.push(a.adj);
      if (state.stage === 'senior' && !cat && !(base && base.senior)) r.push('senioralder');
      if (state.neut && !cat && !(base && base.neut)) r.push('kastrering');
      if (state.lose && !(base && base.lose)) r.push('vægttab');
      return r;
    }
    function curMode() { // "Skal tabe sig" picks the maker's own weight-loss column when there is one
      if (state.lose && state.stage !== 'young') for (var i = 0; i < modes.length; i++) if (/vægttab|overvægt/i.test(modes[i].label.main + ' ' + modes[i].label.sub)) return i;
      return mode;
    }
    function actObj() {
      if (makerModes && kind === 'weight') { // the maker's own columns decide the activity level
        var l = (modes[curMode()].label.main + ' ' + modes[curMode()].label.sub).toLowerCase();
        var id = /ekstrem|brugs|sport|meget aktiv/.test(l) ? 'hoj' : /mindre aktiv|lav aktivitet|inaktiv|indekat|neutral|steril|overvægt|vægttab/.test(l) ? 'lav'
          : /udekat/.test(l) || (/aktiv/.test(l) && !/normal/.test(l)) ? 'aktiv' : 'normal';
        return acts.filter(function (a) { return a.id === id; })[0] || acts[1];
      }
      return acts.filter(function (a) { return a.id === state.act; })[0] || acts[1];
    }

    function estimate(note) {
      if (!kcalKg) return null;
      var n = kcalNeed(cat, state.stage, state.weight, actObj(), state.age, state.adult, state);
      var gr = n.kcal / kcalKg * 1000;
      return { r: { lo: gr * 0.9, hi: gr * 1.1 }, mid: gr, est: true, kcal: n.kcal, bw: n.bw, note: note, floored: n.floored, reasons: reasons(false) };
    }
    function tableWeight(x) {
      var mi = curMode(), mo = modes[mi], res = mo.curve.at(x);
      if (!res) return null;
      if (res.text) return { msg: 'Producenten skriver: «' + res.text + '».', alts: ['text', 'large', 'adult'] };
      var e;
      if (x < mo.curve.min * 0.9) {
        e = estimate('Producentens tabel starter ved ' + num(mo.curve.min) + ' kg, så vi har regnet ud fra foderets energi.');
        if (e) { e.alts = ['small']; return e; }
        return { msg: 'Producentens tabel starter ved ' + num(mo.curve.min) + ' kg, så dette foder er nok ikke beregnet til en ' + who[state.stage] + ' på ' + num(x) + ' kg.', alts: ['small'] };
      }
      if (x > mo.curve.max * 1.1 && !mo.curve.texts.length) {
        e = estimate('Producentens tabel går op til ' + num(mo.curve.max) + ' kg, så vi har regnet ud fra foderets energi.');
        if (e) { e.alts = ['large']; return e; }
        return { msg: 'Producentens tabel går op til ' + num(mo.curve.max) + ' kg. Til en ' + who[state.stage] + ' på ' + num(x) + ' kg kan vi ikke regne mængden sikkert ud.', alts: ['large'] };
      }
      var f = 1, adj = null, fl = false;
      if (state.stage !== 'young') {
        var lbl = mo.label.main + ' ' + mo.label.sub;
        var base = { act: makerModes ? actObj() : acts[1], senior: pStage === 'senior' && state.stage === 'senior',
          neut: /neutral|steril|kastr/i.test(lbl) && state.neut, lose: (/vægttab|overvægt/i.test(lbl) || /målvægt/.test(c0)) && state.lose };
        var me = adultKcal(cat, x, { act: actObj(), senior: state.stage === 'senior', neut: state.neut, lose: state.lose });
        var b0 = adultKcal(cat, x, base);
        f = me.kcal / b0.kcal; fl = me.floored;
        var rs = reasons(base);
        if (Math.abs(f - 1) >= 0.02 && rs.length) adj = (f > 1 ? '+' : '−') + fmt(Math.round(Math.abs(f - 1) * 100)) + ' % for ' + list(rs);
      }
      return { r: { lo: res.lo * f, hi: res.hi * f, e: res.e, below: res.below, above: res.above }, mid: (res.lo + res.hi) / 2 * f, base: (res.lo + res.hi) / 2, adj: adj, floored: fl };
    }

    function computeBase() {
      // Life stage mismatch: say so and show the better food
      if (state.stage === 'young' && pStage !== 'young' && pStage !== 'all')
        return { msg: (state.name ? state.name + ' er' : 'Din ' + who.young + ' er') + ' i vækst. Dette foder er lavet til voksne ' + (cat ? 'katte' : 'hunde') + ', og ' + (cat ? 'en killing' : 'en hvalp') + ' har brug for foder til vækst med mere energi og den rette mængde calcium og fosfor.', alts: ['young'], hard: true };
      if (state.stage !== 'young' && pStage === 'young')
        return { msg: 'Dette er ' + (cat ? 'killingefoder' : 'hvalpefoder') + '. Til ' + (state.name || 'en voksen ' + who.adult) + ' giver det for meget energi, så vælg hellere foder til voksne.', alts: ['adult'], hard: true };

      var out = null;
      if (state.stage === 'young') {
        if (kind === 'puppy') {
          var a = ages.filter(function (x, i) { return state.age >= x.from && (state.age < x.to || (i === ages.length - 1 && state.age <= x.to)); })[0];
          if (!a && state.age < ages[0].from) a = ages[0];
          if (!a) out = { msg: 'Producentens tabel dækker ' + (cat ? 'killinger' : 'hvalpe') + ' op til ' + num(ages[ages.length - 1].to) + ' måneder. Nu er det tid til foder til voksne.', alts: ['adult'] };
          else {
            var r = a.curve.at(state.adult);
            if (r && r.text) out = { msg: 'Til en ' + who.young + ' på den alder og størrelse anbefaler producenten: «' + r.text + '».', alts: ['text', 'large', 'adult'] };
            else if (state.adult < a.curve.min * 0.9 || state.adult > a.curve.max * 1.1) {
              var side = state.adult > a.curve.max ? 'large' : 'small';
              out = estimate('Producentens tabel dækker hunde, der bliver ' + num(a.curve.min) + '-' + num(a.curve.max) + ' kg som voksne, så vi har regnet ud fra foderets energi.') ||
                { msg: 'Producentens tabel dækker hunde, der bliver ' + num(a.curve.min) + '-' + num(a.curve.max) + ' kg som voksne.' };
              out.alts = [side];
            } else if (r) out = { r: r, mid: (r.lo + r.hi) / 2, col: a.label };
          }
        } else if (kind === 'age') {
          var res = modes[mode].curve.at(state.age);
          if (res && res.text) out = { msg: 'Producenten skriver: «' + res.text + '».', alts: ['text', 'adult'] };
          else if (state.age > modes[mode].curve.max * 1.1) out = { msg: 'Producentens tabel går op til ' + num(modes[mode].curve.max) + ' måneder. Nu er det tid til foder til voksne.', alts: ['adult'] };
          else if (res) out = { r: res, mid: (res.lo + res.hi) / 2 };
        } else if (tableYoungWeight) {
          var bw = state.adult * Math.min(1, growShare(cat, state.adult, state.age));
          out = tableWeight(bw);
          if (out && out.r) out.bw = bw;
        } else out = estimate('');
        if (out && !out.msg && state.age >= adultAgeDone(cat, state.adult)) out.alts = (out.alts || []).concat('adult');
      } else {
        if (kind === 'weight' && !tableYoungWeight) out = tableWeight(state.weight);
        else out = estimate('');
        if (out && !out.msg && state.stage === 'senior' && pStage !== 'senior' && pStage !== 'all') out.alts = (out.alts || []).concat('senior');
      }
      return out;
    }
    // Size: Large breed foods are made for dogs over X kg, Small breed foods for dogs up to Y kg (the maker's own limits)
    function sizeCheck() {
      if (cat) return null;
      var young = state.stage === 'young', w = young ? state.adult : state.weight;
      var dog = young ? 'en hvalp, der bliver ' + num(w) + ' kg' : 'en hund på ' + num(w) + ' kg';
      if (mMin && w < mMin) {
        var tg = w <= 10 ? ['small', 'std'] : ['std'];
        return w < mMin * 0.85 ? { hard: true, notice: 'Dette foder er lavet til store hunde over ' + mMin + ' kg' + (young ? ' som voksne' : '') + '. Til ' + dog + ' passer et foder til ' + (w <= 10 ? 'små' : 'almindelige') + ' racer bedre.', alts: tg } : { alts: tg };
      }
      if (mMax && w > mMax) {
        var tg2 = w >= 30 ? ['large', 'std'] : ['std'];
        return w > mMax * 1.15 ? { hard: true, notice: 'Dette foder er lavet til ' + (mMax <= 10 ? 'små' : 'små og mellemstore') + ' hunde op til ' + mMax + ' kg' + (young ? ' som voksne' : '') + '. Til ' + dog + ' passer et foder til ' + (w >= 30 ? 'store' : 'almindelige') + ' racer bedre.', alts: tg2 } : { alts: tg2 };
      }
      if (pSize === 'all' && w >= 30) return { alts: ['large'] };
      if (pSize === 'all' && w <= 10) return { alts: ['small'] };
      return null;
    }
    function avoidNames() { return state.avoid.map(function (a) { return ALLERGY.filter(function (x) { return x[0] === a; })[0][1].toLowerCase(); }); }
    function compute() {
      var out = computeBase();
      if (!out) return out;
      var notices = [], hard = !!out.hard || !!out.msg, front = [], back = [];
      if (!out.msg && !out.hard) {
        var sc = sizeCheck();
        if (sc) { if (sc.notice) notices.push(sc.notice); (sc.hard ? front : back).push.apply(sc.hard ? front : back, sc.alts); hard = hard || !!sc.hard; }
      }
      out.allergy = null;
      if (state.alg) {
        var bad = state.avoid.filter(function (a) { return has[a]; });
        if (bad.length && hasKnown) {
          notices.push('Dette foder indeholder ' + list(bad.map(function (a) { return ALLERGY.filter(function (x) { return x[0] === a; })[0][1].toLowerCase(); })) + ', som ' + (state.name || (cat ? 'din kat' : 'din hund')) + ' ikke tåler.');
          front.push('free', 'sens'); hard = true;
        } else if (state.avoid.length && hasKnown) {
          out.allergy = 'Uden ' + list(avoidNames()) + ' ifølge producentens sammensætning.';
          if (!isSens) back.push('sens');
        } else if (state.avoid.length) {
          out.allergy = 'Vi kender ikke sammensætningen af dette foder, så tjek ingredienslisten for ' + list(avoidNames()) + '.';
          back.push('free', 'sens');
        } else if (!isSens && !state.sens) back.push('sens');
        if (state.sens) { // sensitive stomach or skin without a known allergy: the brand's sensitive / single-protein food
          if (isSens) out.allergy = (out.allergy ? out.allergy + ' ' : '') + 'Foderet er lavet til sensitive ' + (cat ? 'katte' : 'hunde') + '.';
          else back.unshift('sens');
        }
      }
      if (state.lose && state.stage !== 'young' && !isLight) back.push('light');
      out.alts = front.concat(out.alts || [], back, hard ? [] : ['pick']); // pick: ACANA/ORIJEN always show a Profine/Platinum food
      if (notices.length) out.notice = notices.join(' ');
      out.hard = hard;
      return out;
    }
    function meals() {
      if (state.stage === 'young') return cat ? 4 : state.age < 3 ? 4 : state.age < 6 ? 3 : 2;
      return cat ? 0 : 2;
    }

    /* ---------- render ---------- */
    function showAlts(c) {
      if (!altsWrap) return;
      var tags = (c && c.alts) || [], picked = [], onlyText = tags[0] === 'text' && hasAlt('text');
      function tagsOf(card) { return (' ' + card.getAttribute('data-fbfc-alt') + ' '); }
      function safe(card) { // never recommend a food with something the animal can't tolerate (or unknown contents)
        if (!state.alg || !state.avoid.length) return true;
        var t = tagsOf(card);
        return t.indexOf(' c-x ') < 0 && !state.avoid.some(function (a) { return t.indexOf(' c-' + a + ' ') > -1; });
      }
      tags.forEach(function (tg) {
        if (onlyText && tg !== 'text') return;
        altCards.forEach(function (card) {
          if (picked.length >= 2 || picked.some(function (p) { return p.card === card; })) return;
          if (tagsOf(card).indexOf(' ' + tg + ' ') > -1 && safe(card)) picked.push({ card: card, tg: tg });
        });
      });
      var avoidTxt = state.alg && state.avoid.length ? 'Uden ' + list(avoidNames()) : '';
      var label = { young: cat ? 'Til killinger' : 'Til hvalpe', adult: cat ? 'Til voksne katte' : 'Til voksne hunde', senior: cat ? 'Til ældre katte' : 'Til seniorhunde',
        small: state.stage === 'young' ? 'Til hvalpe af små racer' : 'Til små racer', large: state.stage === 'young' ? 'Til hvalpe af store racer' : 'Til store racer',
        std: state.stage === 'young' ? 'Til hvalpe af alle størrelser' : 'Til alle størrelser', sens: 'Til sensitive', free: avoidTxt || 'Til sensitive', light: 'Til vægttab', text: 'Producentens anbefaling', pick: 'Vores anbefaling' };
      altCards.forEach(function (card) { card.hidden = true; });
      picked.forEach(function (p) {
        p.card.hidden = false; altsWrap.appendChild(p.card); // keep the chosen order
        var why = p.card.querySelector('[data-fbfc-why]');
        if (why) why.textContent = avoidTxt && p.tg !== 'text' && p.tg !== 'free' ? label[p.tg] + ' · ' + avoidTxt.toLowerCase() : label[p.tg];
      });
      var hard = !!(c && (c.hard || c.msg));
      if (altHead) altHead.textContent = hard ? 'Det her passer bedre til ' + (state.name || ('din ' + who[state.stage])) : 'Måske et endnu bedre match';
      altsWrap.hidden = !picked.length;
      altsWrap.classList.toggle('is-hard', hard);
      // what each suggestion costs a day for this animal: its own maker's table when it has one (adjusted for activity,
      // age and neutering the same way as above), else the energy need from our model (calibrated to the makers' tables,
      // see ACT) and its energy. Then the bag with the lowest price per day (mini/small bags only for small animals).
      var nn = kcalNeed(cat, state.stage, state.weight, userAct(), state.age, state.adult, state), need = nn && nn.kcal;
      picked.forEach(function (p) { altDay(p.card, need, true); });
    }
    function userAct() { return acts.filter(function (a) { return a.id === state.act; })[0] || acts[1]; }
    function altGrams(card, k, need) {
      var model = k && need ? need / k * 1000 : null, gd = null;
      if (state.stage === 'young') return model;
      try { gd = JSON.parse(card.getAttribute('data-guide') || 'null'); } catch (e) { gd = null; }
      var c0 = gd && gd.columns && gd.rows ? String(gd.columns[0]).toLowerCase() : '';
      if (!c0 || c0.indexOf('vægt') < 0 || /voksenvægt|hvalp|killing/.test(c0)) return model;
      var ci = 1;
      for (var i = 1; i < gd.columns.length; i++) if (!/vægttab|overvægt|ekstrem|meget aktiv|sport|brugs|aktiv/i.test(gd.columns[i]) || /normal/i.test(gd.columns[i])) { ci = i; break; }
      var um = String(gd.columns[ci]).match(/(dåse|bakke|pose)r?\s*\((\d+)\s*g\)/i);
      var cv = curve(gd.rows.map(function (r) { return [r[0], r[ci]]; }), um ? +um[2] : null), x = state.weight;
      if (!(x >= cv.min * 0.9 && x <= cv.max * 1.1)) return model;
      var r = cv.at(x); if (!r || r.text || !r.lo) return model;
      var ttl = (card.querySelector('.fbfc__alt-ttl') || {}).textContent || '';
      var me = adultKcal(cat, x, { act: userAct(), senior: state.stage === 'senior', neut: state.neut, lose: state.lose });
      var b0 = adultKcal(cat, x, { act: acts[1], senior: state.stage === 'senior' && /senior|ældre/i.test(ttl) });
      return (r.lo + r.hi) / 2 * me.kcal / b0.kcal;
    }
    function altOpts(card) {
      var sel = card.querySelector('[data-fbfc-alt-select]');
      var els = sel ? Array.prototype.slice.call(sel.options) : Array.prototype.slice.call(card.querySelectorAll('[data-fbfc-id]'));
      return els.map(function (o) {
        var q = parseFloat(o.getAttribute('data-qty')), u = (o.getAttribute('data-qu') || '').toLowerCase();
        var g = q ? (u === 'kg' ? q * 1000 : u === 'g' ? q : null) : null;
        if (!g) g = parseQty(o.getAttribute('data-title') || o.textContent);
        return { el: o, g: g, cents: +o.getAttribute('data-cents'), t: o.getAttribute('data-title') || o.textContent.trim(), sold: o.hasAttribute('data-sold') };
      });
    }
    function altDay(card, need, pick) {
      var out = card.querySelector('[data-fbfc-alt-day]'); if (!out) return;
      card.setAttribute('data-need', need || '');
      var k = parseEnergy(card.getAttribute('data-kcal')), opts = altOpts(card), sel = card.querySelector('[data-fbfc-alt-select]');
      var gpd = altGrams(card, k, need);
      card.setAttribute('data-gpd', gpd ? Math.round(gpd) : ''); // for the line item properties on Læg i kurv
      if (!gpd || !opts.length) { out.textContent = ''; return; }
      var big = (state.stage === 'young' ? state.adult : state.weight) >= 12;
      opts.forEach(function (o) { o.day = o.g && o.cents ? o.cents / (o.g / gpd) : null; o.fits = o.day && !(big && /mini|small|lille|\bxs\b/i.test(o.t)); o.ok = o.fits && !o.sold; });
      if (pick && sel) {
        var best = null; opts.forEach(function (o) { if (o.ok && (!best || o.day < best.day)) best = o; });
        if (best && sel.value !== best.el.value) { sel.value = best.el.value; var pr = card.querySelector('[data-fbfc-alt-price]'); if (pr) pr.textContent = best.el.getAttribute('data-price'); }
      }
      var cur = sel ? opts.filter(function (o) { return o.el.value === sel.value; })[0] : opts[0];
      if (!cur || !cur.day) { out.textContent = ''; return; }
      var cheaper = opts.filter(function (o) { return o.sold && o.fits && o.day < cur.day - 50; }).sort(function (a, b) { return a.day - b.day; })[0];
      out.innerHTML = '<b>' + money(cur.day) + ' om dagen</b> · ' + grams(gpd) + ' om dagen' + (opts.length > 1 ? ' · ' + esc(cur.t) : '') + (cur.g ? ', holder ' + duration(cur.g / gpd) : '') +
        (cheaper ? '<br>' + esc(cheaper.t) + ' giver ' + money(cheaper.day) + ' om dagen, men er udsolgt lige nu.' : '');
    }

    var planChoice = null, lastRes = null;
    function update() {
      var c = compute(); lastRes = c;
      var nm = state.name ? esc(state.name) : ('Din ' + who[state.stage]);
      if (touched) save(sp, { name: state.name, weight: state.weight, adult: state.adult, age: state.age, act: state.act, neut: state.neut, lose: state.lose, alg: state.alg, sens: state.sens, avoid: state.avoid, breed: state.breed, food: state.food });
      showAlts(c);
      if (srcEl) srcEl.hidden = !(c && c.r);
      if (!c) { resultEl.innerHTML = ''; if (sizesWrap) sizesWrap.hidden = true; if (planEl) planEl.hidden = true; return; }
      if (c.msg) {
        resultEl.innerHTML = '<div class="fbfc__res fbfc__res--msg"><span class="fbfc__msg-ico" aria-hidden="true">!</span><p>' + esc(c.msg) + '</p></div>';
        if (sizesWrap) sizesWrap.hidden = true;
        if (planEl) planEl.hidden = true;
        if (teaser) teaser.textContent = origTeaser;
        return;
      }
      var r = c.r, mid = c.mid;
      var notice = c.notice ? '<div class="fbfc__res fbfc__res--msg fbfc__res--notice"><span class="fbfc__msg-ico" aria-hidden="true">!</span><p>' + esc(c.notice) + '</p></div>' : '';
      var badge = c.est ? '<span class="fbfc__tag fbfc__tag--est">Beregnet skøn</span>' : '<span class="fbfc__tag">Producentens tabel</span>';
      var h = '<div class="fbfc__res' + (c.est ? ' is-est' : '') + '"><div class="fbfc__res-top"><p class="fbfc__res-lead">' + nm + ' skal have</p>' + badge + '</div>' +
        '<p class="fbfc__big"><span class="fbfc__ca">ca.</span> <span data-fbfc-num>' + grams(mid) + '</span> <span class="fbfc__per">om dagen</span></p>';
      var pills = [], nMeals = meals(), smallPack = packGrams && packGrams <= 1000;
      if (smallPack && mid > 0) pills.push(frac(mid / packGrams) + ' ' + (mid / packGrams <= 1.12 ? unitOne : unitWord) + ' à ' + qtyName(packGrams));
      else if (nMeals) pills.push(nMeals + ' måltider à ca. ' + grams(mid / nMeals));
      else pills.push('Gerne fordelt på 2-4 små måltider');
      var kc = c.kcal || (kcalKg ? mid * kcalKg / 1000 : 0);
      if (kc) pills.push('≈ ' + fmt(Math.round(kc / 10) * 10) + ' kcal');
      if (r.e) pills.push('+ ca. ' + grams(r.e) + ' tørfoder');
      h += '<ul class="fbfc__pills">' + pills.map(function (p) { return '<li>' + p + '</li>'; }).join('') + '</ul>';
      var subs = [];
      if (c.est) {
        subs.push((c.note ? c.note + ' ' : 'Producenten har ingen fodringstabel, så vi har regnet ud fra foderets energi (' + fmt(kcalKg / 10) + ' kcal pr. 100 g' + (kcalSrc === 'atwater' ? ', beregnet ud fra næringsindholdet' : '') + ') og ' + (cat ? 'kattens' : 'hundens') + ' energibehov. ') +
          (c.reasons && c.reasons.length ? 'Vi har taget højde for ' + list(c.reasons) + (c.floored ? ', men ikke under hvad ' + (cat ? 'en kat' : 'en hund') + ' bruger i hvile' : '') + '. ' : '') +
          'Start med ' + grams(r.lo) + '-' + grams(r.hi) + ', og justér efter huld.');
      } else {
        if (r.hi - r.lo > mid * 0.08) subs.push('Tabellen siger ' + grams(r.lo) + '-' + grams(r.hi) + '. Start i den lave ende.');
        if (c.adj) subs.push('Tabellens mængde er ' + grams(c.base) + '. Vi har justeret ' + c.adj + (c.floored ? ', men ikke under hvad ' + (cat ? 'en kat' : 'en hund') + ' bruger i hvile' : '') + '.');
        if (r.below || r.above) subs.push('Det er lige ' + (r.below ? 'under' : 'over') + ' producentens tabel, så mængden er et skøn.');
        if (c.col) subs.push('Ud fra tabellens kolonne for ' + esc(c.col.replace(/\.$/, '').toLowerCase()) + '.');
      }
      if (c.bw) subs.push('Vi regner med, at ' + (state.name ? esc(state.name) : (cat ? 'killingen' : 'hvalpen')) + ' vejer ca. ' + num(Math.round(c.bw * 10) / 10) + ' kg nu. Regn efter igen hver måned, mens den vokser.');
      if (c.allergy) subs.push(esc(c.allergy));
      if (subs.length) h += '<p class="fbfc__res-sub">' + subs.join(' ') + '</p>';
      h += '</div>';
      resultEl.innerHTML = notice + h;
      animateNum(resultEl.querySelector('[data-fbfc-num]'), lastMid, mid);
      lastMid = mid;
      // Claude fixes 71 (P21): the g/day the customer worked out, for the product page's soft subscription-interval warning.
      if (touched) save('gpd', { g: Math.round(mid), sp: sp, t: Date.now() });

      // sizes
      var best = null, maxDays = 0;
      // Claude 2026-10-09 (Mads): decide per size. Only a size that lasts under a week (small bags, cans) is shown
      // as "N stk. holder ca. 2 uger"; bigger bags always show how long one bag lasts.
      sizes.forEach(function (s) {
        var days = s.grams / mid;
        var daysEl = s.el.querySelector('[data-fbfc-days]'), dayEl = s.el.querySelector('[data-fbfc-perday]');
        var qtyIn = s.el.querySelector('[data-fbfc-qty]'), atc = s.el.querySelector('[data-fbfc-atc]');
        var n = days < 7 ? Math.min(99, Math.max(1, Math.ceil(14 / days))) : 1;
        daysEl.textContent = n > 1 ? n + ' stk. holder ' + duration(n * days) : 'Holder ' + duration(days);
        s.perDay = s.price / days;
        dayEl.textContent = money(s.perDay) + ' om dagen';
        if (qtyIn) qtyIn.value = n;
        var pr = s.el.querySelector('.fbfc__size-price');
        if (pr) { if (!pr.getAttribute('data-orig')) pr.setAttribute('data-orig', pr.textContent); pr.textContent = pr.getAttribute('data-orig') + (n > 1 ? ' pr. stk.' : ''); }
        if (atc) atc.textContent = n > 1 ? 'Læg ' + n + ' stk. i kurv' : 'Læg i kurv';
        s.days = days; maxDays = Math.max(maxDays, days);
        if (s.available && (!best || s.perDay < best.perDay - 0.5)) best = s;
      });
      sizes.forEach(function (s) {
        var b = s.el.querySelector('[data-fbfc-best]');
        if (b) b.hidden = !(best && s === best && sizes.filter(function (x) { return x.available; }).length > 1);
        s.el.classList.toggle('is-best', !!(best && s === best && sizes.length > 1));
        var bar = s.el.querySelector('[data-fbfc-bar]');
        if (bar) { bar.hidden = sizes.length < 2; bar.style.setProperty('--w', Math.max(6, Math.min(100, s.days / maxDays * 100)) + '%'); }
      });
      if (sizesWrap) sizesWrap.hidden = !sizes.length;

      // subscription suggestion
      if (planEl) {
        var plans = (data.plans || []).map(function (p) {
          var mm = p.name.match(/(\d+)?\.?\s*(uge|måned|dag)/i); if (!mm) return null;
          var k = mm[1] ? +mm[1] : 1, unit = mm[2].toLowerCase();
          return { id: p.id, name: p.name, pct: p.pct, days: k * (unit === 'uge' ? 7 : unit === 'måned' ? 30.4 : 1) };
        }).filter(Boolean).sort(function (a, b) { return a.days - b.days; });
        // subscription size: a bag whose length matches a delivery interval, so food doesn't pile up.
        // For each size take the longest plan that arrives before the bag is empty (Mads: rather a little
        // too much than too little); prefer sizes where the bag lasts at most 1.5x that interval, cheapest per day.
        var allPlans = plans, pick = null, bs = null;
        function plansFor(sz) {
          var v = (sz.el.getAttribute('data-plans') || '').split(',').filter(Boolean);
          return v.length ? allPlans.filter(function (p) { return v.indexOf(String(p.id)) > -1; }) : allPlans;
        }
        function fitFor(sz, q) { var f = null; plansFor(sz).forEach(function (p) { if (p.days <= sz.days * (q || 1)) f = p; }); return f; }
        // Claude 2026-10-09 (Mads): a big dog can get 2 (or more) bags per delivery, so the amount matches an interval.
        // The fewest bags that fit within 1.5x an interval, but more bags when that reaches free shipping
        // (499 kr. per delivery). Mads: never several bags that last longer than 2.5 months together.
        var cands = sizes.filter(function (sz) { return sz.available; }).map(function (sz) {
          var maxQ = sz.days < 7 ? 99 : 4, alt = null, first = null;
          for (var q = 1; q <= maxQ; q++) {
            if (q > 1 && sz.days * q > 76) break;
            var f = fitFor(sz, q); if (!f) continue;
            var c = { s: sz, p: f, q: q, r: sz.days * q / f.days };
            if (c.r <= 1.5) {
              if (!first) first = c;
              if (sz.price * q * (1 - (f.pct || 0) / 100) >= 49900) return c;
            }
            if (!alt || c.r < alt.r) alt = c;
          }
          return first || alt;
        }).filter(Boolean);
        var good = cands.filter(function (c) { return c.r <= 1.5; });
        var pool = good.length ? good : cands;
        pool.sort(function (a, b) { return good.length ? (a.s.perDay - b.s.perDay) || (a.q - b.q) : a.r - b.r; });
        var bq = 1;
        if (pool[0]) { bs = pool[0].s; pick = pool[0].p; bq = pool[0].q; }
        if (bs) plans = plansFor(bs);
        if (pick) {
          // the customer may pick another interval in the box; keep it if it still exists
          var chosen = plans.filter(function (p) { return String(p.id) === String(planChoice); })[0];
          var pl = chosen || pick;
          var nmTxt = state.name ? esc(state.name) + (/[sxz]$/i.test(state.name) ? "'" : 's') : 'Din';
          var canAdd = bs.available && bs.el.getAttribute('data-id') && pl.id;
          var pct = pl.pct || 0, saveC = bs.price * bq * pct / 100, subPrice = bs.price * bq - saveC;
          // per year/month from what the pet eats (bag price per day), not from the delivery interval
          // Claude 2026-10-09 (Mads): parcel-shop shipping is 39 kr. under 499 kr. and free above. With several bags
          // that together reach 499 kr. (one bag alone would not), each delivery saves those 39 kr.
          var shipC = (bq > 1 && subPrice >= 49900 && bs.price * (1 - pct / 100) < 49900) ? 3900 : 0;
          var perYear = (saveC + shipC) / (bs.days * bq) * 365, perMonth = subPrice / (bs.days * bq) * 30.4;
          var bagTxt = bq > 1 ? bq + ' × ' + qtyName(bs.grams) : qtyName(bs.grams);
          var late = pl.days > bs.days * bq;
          var kr0 = function (c) { return fmt(Math.round(c / 100)) + ' kr.'; };
          var opts = plans.map(function (p) { return '<option value="' + p.id + '"' + (p === pl ? ' selected' : '') + '>' + esc(p.name) + (p === pick ? ' (anbefalet)' : '') + '</option>'; }).join('');
          var ticks = [];
          if (pct) ticks.push(fmt(pct) + ' % rabat på hver eneste levering');
          ticks.push('Kommer automatisk, så foderskålen aldrig står tom');
          ticks.push('Spring over, ryk eller opsig når som helst');
          if (shipC) ticks.push('Fri fragt til pakkeshop: ' + bq + ' poser sammen er over 499 kr., så du sparer 39 kr. i fragt hver gang');
          else if (subPrice >= 49900) ticks.push('Fri fragt til pakkeshop (over 499 kr.)');
          planEl.innerHTML =
            '<div class="fbfc__plan-main"><div class="fbfc__plan-a">' +
              '<p class="fbfc__plan-kicker">Fast levering' + (pct ? ' · spar ' + fmt(pct) + ' %' : '') + '</p>' +
              ((pct || shipC) && perYear >= 5000 ? '<p class="fbfc__plan-big">Spar ca. ' + kr0(perYear) + ' om året' + (shipC ? ' inkl. fri fragt' : '') + '</p>' : '') +
              '<p class="fbfc__plan-txt"><b>' + (bq > 1 ? bagTxt + ' holder ' + (state.name ? esc(state.name) + ' ' : '') + duration(bs.days * bq) + '.</b> Vi sender ' + bq + ' poser ' : nmTxt + ' ' + qtyName(bs.grams) + '-pose holder ' + duration(bs.days) + '.</b> Vi sender en ny ') + esc(pl.name.toLowerCase()) + ', ' + (late ? 'men så løber foderet tør før. Vælg et kortere interval.' : pl !== pick && pl.days < bs.days * bq * 0.6 ? 'men så får I mere foder, end I bruger. Det anbefalede interval passer bedre.' : (bq > 1 ? 'så de kommer, før de gamle er tomme.' : 'så den kommer, før den gamle er tom.')) + (bq === 1 && best && best !== bs && best.days > bs.days ? ' Vi foreslår ' + qtyName(bs.grams) + ', fordi ' + qtyName(best.grams) + ' holder længere end vores længste interval, og foderet skal helst bruges, mens det er friskt.' : '') + '</p>' +
              '<p class="fbfc__plan-price">' + (pct ? '<s>' + money(bs.price * bq) + '</s> ' : '') + '<b>' + money(subPrice) + '</b> pr. levering' + (pct || shipC ? '<br><span class="fbfc__plan-save">Du sparer ' + money(saveC + shipC) + ' hver gang' + (shipC ? ' (' + (pct ? money(saveC) + ' rabat + ' : '') + money(shipC) + ' fragt)' : '') + '</span>' : '') + '</p>' +
              '<p class="fbfc__plan-month">Svarer til ca. ' + kr0(perMonth) + ' om måneden for foderet</p>' +
            '</div><div class="fbfc__plan-b">' +
              '<ul class="fbfc__plan-ticks">' + ticks.map(function (t) { return '<li>' + t + '</li>'; }).join('') + '</ul>' +
              '<label class="fbfc__plan-int"><span>Levering</span><select data-fbfc-plan-sel>' + opts + '</select></label>' +
              '<button type="button" class="fbfc__plan-btn" data-fbfc-goplan' + (canAdd ? ' data-id="' + bs.el.getAttribute('data-id') + '" data-plan="' + pl.id + '" data-qty="' + bq + '"' : '') + '><span>' + (canAdd ? 'Start fast levering af ' + bagTxt + (pct || shipC ? ' · spar ' + money(saveC + shipC) : '') : 'Vælg fast levering') + '</span></button>' +
              '<p class="fbfc__plan-fine">Ingen binding. Rabatten gælder fra i dag.</p>' +
            '</div></div>';
          planEl.hidden = false;
          // the same saving on each size card
          sizes.forEach(function (sz) {
            var el = sz.el.querySelector('[data-fbfc-subprice]'); if (!el) return;
            var ok = pct && sz.available && (sz.el.getAttribute('data-plans') || '').split(',').indexOf(String(pl.id)) > -1;
            el.hidden = !ok; if (ok) el.textContent = 'Med fast levering: ' + money(sz.price * (1 - pct / 100));
          });
        } else planEl.hidden = true;
      }

      if (teaser) {
        var at = ageText(state.age), tx = at.v + ' ' + at.u + (state.stage === 'young' ? '' : ', ' + num(state.weight) + ' kg') + ': ca. ' + grams(mid) + ' om dagen';
        if (best) tx += ' · ' + qtyName(best.grams) + ' holder ' + duration(best.days);
        teaser.textContent = (state.name ? state.name + ', ' : 'Til ') + tx;
      }
    }

    // wide two-column layout: put the suggestions under the shorter column, so neither side leaves a big gap
    var bodyEl = root.querySelector('.fbfc__body'), mainEl = root.querySelector('.fbfc__main'), leftEl = null, altsHome = altsWrap && altsWrap.nextSibling;
    function balance() {
      if (!altsWrap || !bodyEl || !mainEl || !root.classList.contains('fbfc--inline')) return;
      if (!leftEl) { leftEl = document.createElement('div'); leftEl.className = 'fbfc__left'; bodyEl.insertBefore(leftEl, inputs); leftEl.appendChild(inputs); }
      var wide = getComputedStyle(bodyEl).display === 'grid';
      bodyEl.insertBefore(altsWrap, altsHome && altsHome.parentNode === bodyEl ? altsHome : null);
      altsWrap.classList.remove('is-col');
      if (!wide || altsWrap.hidden) return;
      // always under the shorter column: never taller than putting it full width below both
      var target = leftEl.offsetHeight > mainEl.offsetHeight ? mainEl : leftEl;
      if (target) { target.appendChild(altsWrap); altsWrap.classList.add('is-col'); }
    }
    // usage data (Claude fixes 73): what the visitor entered, for the event, the cart attributes and the line item properties
    var pageType = root.closest('[data-fb-cp-calc]') ? 'page' : root.closest('.fb-calc') || /\/blogs\//.test(location.pathname) ? 'blog' : /\/pages\//.test(location.pathname) ? 'page' : 'product';
    var handle = data.handle || '', evT = null;
    function kg(v) { return v ? String(Math.round(v * 10) / 10) : ''; }
    function answers() {
      var c = lastRes, young = state.stage === 'young', a = actObj();
      return { young: young, gpd: c && !c.msg && c.mid ? Math.round(c.mid) : 0,
        weight: young ? (c && c.bw) || 0 : state.weight, act: young ? '' : makerModes && kind === 'weight' ? modes[curMode()].label.main : a.main,
        avoid: state.alg ? avoidNames() : [], sens: state.alg && state.sens };
    }
    function bagDays(grams, gpd) { return grams && gpd ? Math.floor(grams / gpd) : null; }
    function capture() {
      if (!touched || !lastRes) return;
      var v = answers(), yes = function (b) { return b ? 'ja' : 'nej'; };
      clearTimeout(evT);
      evT = setTimeout(function () {
        if (evSent[sp]) return; evSent[sp] = true;
        publish({ species: sp, weight_kg: +kg(v.weight) || null, adult_weight_kg: v.young ? state.adult : null, age_months: state.age, age_group: v.young ? who.young : state.stage === 'senior' ? 'senior' : 'voksen',
          activity: v.act || null, neutered: !v.young && !cat ? state.neut : null, weight_loss: !v.young ? state.lose : null, allergies: v.avoid, sensitive: !!v.sens,
          g_per_day: v.gpd || null, product: handle, page_type: pageType, result: v.gpd ? 'beregnet' : 'besked',
          breed: state.breed || null, current_food: state.food || null });
      }, 2000);
      // the bag that is cheapest per day (as in the size cards), for the "bag is nearly empty" date
      var bag = null;
      if (v.gpd) sizes.forEach(function (s) { if (s.available && (!bag || s.price / s.grams < bag.price / bag.grams - 1e-9)) bag = s; });
      var at = ageText(state.age), days = bag ? bagDays(bag.grams, v.gpd) : null, P = 'Foderberegner ';
      var a = {};
      a[P + 'brugt'] = 'ja';
      a[P + 'dyr'] = sp;
      a[P + 'navn'] = state.name || '';
      a[P + 'vægt kg'] = kg(v.weight);
      a[P + 'voksenvægt kg'] = v.young ? kg(state.adult) : '';
      a[P + 'alder'] = at.v + ' ' + at.u + ' (' + state.age + ' mdr.)';
      a[P + 'livsfase'] = v.young ? who.young : state.stage === 'senior' ? 'senior' : 'voksen';
      a[P + 'aktivitet'] = v.act;
      a[P + 'kastreret'] = !v.young && !cat ? yes(state.neut) : '';
      a[P + 'slankekur'] = !v.young ? yes(state.lose) : '';
      a[P + 'allergier'] = state.alg ? (v.avoid.join(', ') || 'ingen valgt') : 'nej';
      a[P + 'sensitiv'] = yes(v.sens);
      a[P + 'g pr dag'] = v.gpd ? String(v.gpd) : '';
      a[P + 'produkt'] = handle;
      // fixes 77: pose, dage and forventet tom are filled in from the cart (composeAttrs); anbefalet pose = cheapest per day
      a[P + 'pose'] = '';
      a[P + 'dage'] = '';
      a[P + 'anbefalet pose'] = bag ? qtyName(bag.grams) : '';
      a[P + 'dage pr pose'] = v.gpd ? sizes.map(function (s) { return qtyName(s.grams) + ': ' + bagDays(s.grams, v.gpd); }).join(', ') : '';
      a[P + 'forventet tom'] = '';
      a[P + 'race'] = state.breed || '';
      a[P + 'nuværende foder'] = state.food || '';
      a[P + 'side'] = pageType;
      // Claude fixes 79 (blog CRO #1): which blog post the calculator was used on, e.g. "/blogs/hund/bedste-hundefoder"; empty elsewhere
      a[P + 'artikel'] = pageType === 'blog' && /^\/blogs\//.test(location.pathname) ? location.pathname : '';
      a[P + 'dato'] = isoDay(0);
      calcCtx = { handle: handle, gpd: v.gpd || 0, byId: {} };
      sizes.forEach(function (s) { calcCtx.byId[+s.el.getAttribute('data-id')] = { grams: s.grams, title: s.el.getAttribute('data-title') || '' }; });
      queueAttrs(a);
    }
    // hidden line item properties for the calculator's own Læg i kurv (underscore: never shown to the customer)
    function lineProps(id, qty, btn) {
      var p = { _foderberegner: '1' };
      if (!touched && !store.weight && !store.age) return p; // nothing entered: the defaults are not this pet
      var v = answers(), grams = 0, gpd = v.gpd;
      var own = sizes.filter(function (s) { return +s.el.getAttribute('data-id') === id; })[0];
      if (own) grams = own.grams;
      else {
        var card = btn && btn.closest('[data-fbfc-alt]');
        gpd = card ? Math.round(+card.getAttribute('data-gpd') || 0) : 0;
        var o = card ? altOpts(card).filter(function (x) { return +x.el.value === id; })[0] : null;
        grams = o && o.g;
      }
      if (gpd) p._g_pr_dag = String(gpd);
      var days = bagDays(grams * qty, gpd);
      if (days !== null) { p._dage_pr_pose = String(days); p._forventet_tom = isoDay(days); }
      p._dyr = sp;
      if (v.weight) p._vaegt_kg = kg(v.weight);
      if (state.breed) p._race = state.breed;
      if (state.food) p._nuvaerende_foder = state.food;
      return p;
    }

    var updateCore = update;
    update = function () {
      updateCore(); balance(); capture();
      if (touched && ownInput && lastRes && lastRes.r && !lastRes.msg && lastRes.mid) trin('resultat_vist');
    };
    // aabnet: the calculator is open and at least partly on screen (20 % of it, or 200 px). Not on page load alone:
    // a calculator in a closed tab, accordion or a collapsed box does not count until it is opened.
    if (window.IntersectionObserver) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (en) {
          if (!en.isIntersecting || !root.open || stepSent.aabnet) return;
          if (en.intersectionRatio >= 0.2 || en.intersectionRect.height >= 200) { trin('aabnet'); io.disconnect(); }
        });
        if (stepSent.aabnet) io.disconnect();
      }, { threshold: [0, 0.05, 0.1, 0.2, 0.35, 0.5] });
      io.observe(root);
      root.addEventListener('toggle', function (e) { if (e.target === root && root.open && !stepSent.aabnet) { io.unobserve(root); io.observe(root); } });
    }
    var balT; window.addEventListener('resize', function () { clearTimeout(balT); balT = setTimeout(balance, 150); });

    // subscription: add the best size with the suggested selling plan, else scroll to the subscription box
    function goToPlanBox() {
      var w = Array.prototype.filter.call(document.querySelectorAll('.appstle_sub_widget, [id^="appstle_subscription_widget"], .appstle-subscription-widget, [class*="appstle_"]'), function (el) { return el.offsetParent !== null && !root.contains(el); })[0];
      // in a blog article there is no subscription box on the page: open the product page instead
      var blog = !w && root.closest('.fb-calc'), link = blog && blog.querySelector('a[href*="/products/"]');
      if (link) { window.location.href = link.href; return; }
      var target = w || document.querySelector('form[action*="/cart/add"]');
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-fbfc-goplan]'); if (!btn || btn.disabled) return;
      var id = +btn.getAttribute('data-id'), plan = +btn.getAttribute('data-plan');
      if (!id || !plan) { goToPlanBox(); return; }
      var q = Math.max(1, +btn.getAttribute('data-qty') || 1);
      trin('laeg_i_kurv');
      addToCart(btn, { id: id, quantity: q, selling_plan: plan, properties: lineProps(id, q, btn) }, goToPlanBox);
    });
    root.addEventListener('change', function (e) {
      var ps = e.target.closest('[data-fbfc-plan-sel]'); if (!ps) return;
      planChoice = ps.value; update();
    });
    // "Beregn med dette foder": keep this dog's answers and recalculate with the suggested food.
    // On /pages/foderberegner the page swaps the calculator; elsewhere the product page opens at its calculator.
    root.addEventListener('click', function (e) {
      var sw = e.target.closest('[data-fbfc-switch]');
      var page = root.closest('[data-fb-cp-calc]');
      if (!sw && page) { var a = e.target.closest('.fbfc__alt-ttl, .fbfc__alt-img'); if (a) sw = a.closest('[data-fbfc-alt]').querySelector('[data-fbfc-switch]'); }
      if (!sw) return;
      e.preventDefault();
      touched = true; update();
      var url = sw.getAttribute('data-fbfc-switch');
      if (page) { page.dispatchEvent(new CustomEvent('fbfc:switch', { bubbles: true, detail: { url: url, title: sw.getAttribute('data-title') } })); return; }
      window.location.href = url + '#foderberegner';
    });
    // variant select on a product card: keep the price in step
    root.addEventListener('change', function (e) {
      var sel = e.target.closest('[data-fbfc-alt-select]'); if (!sel) return;
      var o = sel.options[sel.selectedIndex], pr = sel.closest('[data-fbfc-alt]').querySelector('[data-fbfc-alt-price]');
      if (o && pr) pr.textContent = o.getAttribute('data-price');
      var card = sel.closest('[data-fbfc-alt]'); altDay(card, +card.getAttribute('data-need'), false);
    });

    /* Claude fixes 75 (Mads): "Din pose er snart tom". After a one-time calculator add that has an expected empty date,
       keep a small record in localStorage 'fbpose' (newest 3, one per variant, no pet name). It counts as bought only
       when assets/fb-pose-reminder.js later sees the visitor go to checkout and the cart come back without the item.
       Subscriptions are skipped (they never run out). */
    function poseRec(item, btn) {
      try {
        var pr = item.properties || {};
        if (item.selling_plan || !pr._forventet_tom || !window.localStorage) return;
        var card = btn && btn.closest('[data-fbfc-alt]'), h = handle, t = data.title || '', bag = '';
        if (card) {
          var a = card.querySelector('.fbfc__alt-ttl'), m = a && (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
          h = m ? decodeURIComponent(m[1]) : ''; t = a ? a.textContent.trim() : '';
          var o = altOpts(card).filter(function (x) { return +x.el.value === item.id; })[0];
          bag = o && o.g ? qtyName(o.g) : '';
        } else {
          var own = sizes.filter(function (s) { return +s.el.getAttribute('data-id') === item.id; })[0];
          bag = own ? qtyName(own.grams) : '';
        }
        if (!h || !t) return;
        var list = []; try { list = JSON.parse(localStorage.getItem('fbpose') || '[]') || []; } catch (e) { list = []; }
        list = list.filter(function (r) { return r && r.v !== item.id; });
        list.unshift({ h: h, t: t, v: item.id, b: bag, q: item.quantity || 1, e: pr._forventet_tom, d: +pr._dage_pr_pose || 0, s: sp, a: isoDay(0), st: 'incart' });
        localStorage.setItem('fbpose', JSON.stringify(list.slice(0, 3)));
      } catch (e) {}
    }
    // Læg i kurv: /cart/add.js, then the theme's own cart drawer (no <form> here, see the snippet header)
    function addToCart(btn, item, onFail) {
      var label = btn.querySelector('span'), old = label ? label.textContent : '';
      btn.disabled = true; btn.classList.add('is-loading'); if (label) label.textContent = 'Lægger i kurv …';
      var rootUrl = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(rootUrl + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [item] }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function (j) {
          // Subscription: some apps (Appstle's widget script) rewrite AJAX cart adds from the page's own purchase-option
          // radio, which can drop our selling_plan. Check the line and set the plan with /cart/change.js if it is missing.
          if (!item.selling_plan) return j;
          var key = j && j.items && j.items[0] && j.items[0].key;
          return fetch(rootUrl + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
            var line = (cart.items || []).filter(function (it) { return key ? it.key === key : it.variant_id === item.id; })[0];
            if (!line || (line.selling_plan_allocation && line.selling_plan_allocation.selling_plan && line.selling_plan_allocation.selling_plan.id === item.selling_plan)) return j;
            return fetch(rootUrl + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ id: line.key, quantity: line.quantity, selling_plan: item.selling_plan, properties: item.properties }) }).then(function (r) { if (!r.ok) throw r; return j; });
          });
        })
        .then(function () {
          if (label) label.textContent = 'Lagt i kurv ✓';
          poseRec(item, btn);
          var $ = window.jQuery;
          if ($ && typeof window.buildCart === 'function') { // same steps as the theme's Sd_addProduct handler
            $('[data-drawer-body]').html(window.preLoadLoadGif || '');
            $('[data-side-drawer]').attr('class', 'yv_side_drawer_wrapper').attr('id', 'mini__cart').addClass('mini_cart');
            if (window.cartTitleLabel) $('[data-drawer-title]').html(window.cartTitleLabel);
            $('body').addClass('side_Drawer_open');
            $.getJSON(window.cartUrl || rootUrl + 'cart.js', function (cart) { window.buildCart(cart, true); });
          } else if (!window.fbfcPreview) window.location.href = rootUrl + 'cart';
          document.dispatchEvent(new CustomEvent('fbfc:added', { detail: item }));
        })
        .catch(function () { if (label) label.textContent = 'Kunne ikke lægges i kurv'; if (onFail) onFail(); })
        .then(function () { setTimeout(function () { btn.disabled = false; btn.classList.remove('is-loading'); if (label) label.textContent = old; }, 1800); });
    }
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-fbfc-add]'); if (!btn || btn.disabled) return;
      e.preventDefault();
      var box = btn.closest('[data-fbfc-buy]'), sel = box.querySelector('select'), idEl = box.querySelector('[data-fbfc-id]'), qEl = box.querySelector('[data-fbfc-qty]');
      var id = +(sel ? sel.value : idEl && idEl.value), qty = Math.max(1, +(qEl && qEl.value) || 1);
      if (!id) return;
      trin('laeg_i_kurv');
      addToCart(btn, { id: id, quantity: qty, properties: lineProps(id, qty, btn) });
    });
    // forslag_klikket: any click on a suggestion card (title, image, size, Læg i kurv or "Beregn med dette foder")
    root.addEventListener('click', function (e) { if (e.target.closest('[data-fbfc-alt]')) trin('forslag_klikket'); });

    if (noteEl && g && g.note) noteEl.textContent = g.note;
    renderInputs();
    update();
    if (store.weight || store.age) root.classList.add('has-saved');
  }

  function run() { document.querySelectorAll('[data-fbfc]').forEach(function (r) { if (!r.fbfcDone) { r.fbfcDone = true; init(r); } }); }
  window.fbfcRun = run; // Claude 2026-10-09: lets /pages/foderberegner init a calculator loaded later
  function toCalc() {
    if (location.hash !== '#foderberegner') return;
    var all = Array.prototype.slice.call(document.querySelectorAll('[data-fbfc]'));
    var r = all.filter(function (x) { return x.offsetParent !== null; })[0];
    if (!r && all[0]) {
      // inside a closed tab or accordion: click the control that opens it
      for (var el = all[0].parentElement; el && el !== document.body; el = el.parentElement) {
        if (el.id && getComputedStyle(el).display === 'none') {
          var t = document.querySelector('[aria-controls="' + el.id + '"], [href="#' + el.id + '"], [data-target="#' + el.id + '"], [data-bs-target="#' + el.id + '"]');
          if (t) t.click();
        }
      }
      r = all.filter(function (x) { return x.offsetParent !== null; })[0] || all[0];
    }
    if (!r) return;
    r.open = true;
    setTimeout(function () { r.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 300);
  }
  function start() { run(); toCalc(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', run);
})();
